/* ============================================================
   Beneos "Your Library" search engine (web port of the Foundry
   module cloud window). Loads the full public Beneos catalog via
   window.BeneosDB, overlays the App-Proxy library (owned assets
   carry cloudId + source), and renders a faceted browser:
   FacetSelect -> active chip strips, CR/price/grid range slider,
   access chips, grid/list, detail modal, owned download. Layer 2
   (content -> product) is fetched per asset for non-owned items.

   Public API:  window.BeneosSearch.init(rootEl, { proxyUrl, locale, patreonUrl, shopUrl })
   ============================================================ */
(function () {
  'use strict';

  var SVG = {
    search: '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><circle cx="11" cy="11" r="7"/><path d="M21 21l-4.3-4.3"/></svg>',
    chev: '<svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"><path d="M6 9l6 6 6-6"/></svg>',
    x: '<svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4"><path d="M5 5l14 14M19 5L5 19"/></svg>',
    dl: '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7"><path d="M12 3v12m0 0l-4-4m4 4l4-4M5 21h14"/></svg>',
    lock: '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7"><rect x="4" y="11" width="16" height="9" rx="2"/><path d="M8 11V8a4 4 0 0 1 8 0v3"/></svg>',
    grid: '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7"><rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/><rect x="14" y="14" width="7" height="7"/></svg>',
    list: '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7"><path d="M8 6h13M8 12h13M8 18h13M3 6h.01M3 12h.01M3 18h.01"/></svg>',
    check: '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg>'
  };

  // Uebersetzte Beschriftung. Die Bruecke liegt in snippets/beneos-i18n.liquid
  // und wird von der Section gerendert, die diese Datei laedt. Faellt sie aus,
  // bleibt der englische Rueckfallwert stehen, nie eine leere Flaeche.
  function T(k, d) {
    var s = (window.Beneos && window.Beneos.strings) || {};
    var v = (s[k] != null && s[k] !== '') ? s[k] : d;
    // Shopify maskiert Uebersetzungswerte zu HTML-Entitaeten, ausser der
    // Schluessel endet auf _html. Hier wird wieder Rohtext daraus, damit die
    // Aufrufstelle selbst entscheidet, ob sie esc() braucht. Ohne diesen
    // Schritt stuende "Dungeons & Dragons" als "Dungeons &amp;amp; Dragons"
    // auf der Seite, weil esc() ein zweites Mal maskiert.
    return String(v).replace(/&(amp|lt|gt|quot|#39);/g, function (m, e) {
      return { 'amp': '&', 'lt': '<', 'gt': '>', 'quot': '"', '#39': "'" }[e];
    });
  }

  // Per-type facet definitions. path = beneos_i18n catPath (best-effort).
  var FACETS = {
    token: {
      tab: T('search.tab_creatures', 'Creatures'), thumbField: 'thumbnail', aspect: 'square', range: { key: 'cr', label: T('search.f_cr', 'Challenge rating'), max: 30 },
      selects: [
        { key: 'biom', label: T('search.f_biome', 'Biome'), arr: true, path: 'common.biome' },
        { key: 'type', label: T('search.f_creature_type', 'Creature type'), arr: true, path: 'token.type' },
        { key: 'faction', label: T('search.f_faction', 'Faction'), arr: true, path: 'token.faction' },
        { key: 'fightingstyle', label: T('search.f_fighting_style', 'Fighting style'), arr: true, path: 'token.fightingstyle' },
        { key: 'purpose', label: T('search.f_purpose', 'Purpose'), arr: true, path: 'token.purpose' },
        { key: 'size', label: T('search.f_size', 'Size'), path: 'common.size' }
      ]
    },
    battlemap: {
      tab: T('search.tab_battlemaps', 'Animated Battlemaps'), thumbField: 'thumbnail', aspect: 'wide', range: null,
      selects: [
        { key: 'biom', label: T('search.f_biome', 'Biome'), arr: true, path: 'common.biome' },
        { key: 'adventure', label: T('search.f_adventure', 'Adventure'), arr: true, path: 'battlemap.adventure' },
        { key: 'type', label: T('search.f_type', 'Type'), path: 'battlemap.type' },
        { key: 'brightness', label: T('search.f_brightness', 'Brightness'), path: 'battlemap.brightness' },
        { key: 'grid', label: T('search.f_grid', 'Grid'), path: 'battlemap.grid' }
      ]
    },
    spell: {
      tab: T('search.tab_spells', 'Spells'), thumbField: 'icon', aspect: 'square', range: null,
      selects: [
        { key: 'level', label: T('search.f_level', 'Level'), path: 'spell.level' },
        { key: 'school', label: T('search.f_school', 'School'), path: 'spell.school' },
        { key: 'spell_type', label: T('search.f_effect', 'Effect'), path: 'spell.spell_type' },
        { key: 'casting_time', label: T('search.f_casting_time', 'Casting time'), path: 'spell.casting_time' },
        { key: 'classes', label: T('search.f_class', 'Class'), arr: true, path: 'spell.classes' }
      ]
    },
    item: {
      tab: T('search.tab_items', 'Items'), thumbField: 'icon', aspect: 'card', range: { key: 'price', label: T('search.f_price', 'Price (gp)'), max: 50000 },
      selects: [
        { key: 'rarity', label: T('search.f_rarity', 'Rarity'), path: 'item.rarity' },
        { key: 'origin', label: T('search.f_origin', 'Origin'), path: 'item.origin' },
        { key: 'item_type', label: T('search.f_item_type', 'Item type'), path: 'item.item_type' },
        { key: 'tier', label: T('search.f_tier', 'Tier'), path: 'item.tier' }
      ]
    }
  };
  // Alphabetisch nach dem Namen, den der Kunde liest: Animated Battlemaps,
  // Creatures, Items, Spells. Die Reihenfolge steuert nur die Anzeige; Zustand und
  // Filter haengen an den Schluesseln, nicht an der Position.
  var KIND_ORDER = ['battlemap', 'token', 'item', 'spell'];
  var PAGE = 60;

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function withParam(url, kv) { return url + (url.indexOf('?') === -1 ? '?' : '&') + kv; }
  function crToNum(v) {
    if (v == null || v === '') return null;
    var s = String(v).trim();
    if (s.indexOf('/') !== -1) { var p = s.split('/'); return (parseFloat(p[0]) / parseFloat(p[1])) || 0; }
    var n = parseFloat(s); return isNaN(n) ? null : n;
  }
  function priceToNum(v) { if (v == null) return null; var n = parseFloat(String(v).replace(/[^0-9.]/g, '')); return isNaN(n) ? null : n; }
  // Descending numeric compare that pushes missing values (null/NaN) to the
  // end of the group, so "no CR/level/price yet" never outranks a real 0.
  function cmpNullsLast(a, b) {
    var an = (a == null || isNaN(a)), bn = (b == null || isNaN(b));
    if (an && bn) return 0;
    if (an) return 1;
    if (bn) return -1;
    return b - a;
  }
  // "32x18" -> 576. Non-parsable grid strings yield null (sorted last).
  function gridArea(g) {
    var m = /(\d+)\s*[xX]\s*(\d+)/.exec(String(g || ''));
    return m ? parseInt(m[1], 10) * parseInt(m[2], 10) : null;
  }
  // Kind-specific metric behind the 4th sort option: CR (token), spell level
  // (spell, cantrip counts as 0), gold price (item). Battlemaps never reach
  // this path (they sort in their own view branches).
  function rankValue(it) {
    if (it.kind === 'token') return it.cr;
    if (it.kind === 'spell') { var lv = parseFloat(it.props && it.props.level); return isNaN(lv) ? null : lv; }
    if (it.kind === 'item') return it.price;
    return null;
  }

  // Patreon membership state, fed in from beneos-library.js once the Patreon
  // strip has resolved resource=connections. Module scope on purpose: the
  // strip and the browser load independently, so the setter can fire BEFORE
  // init() runs and the value must survive that. null = not reported yet, in
  // which case the browser derives it from the release payload instead.
  var patronActive = null;
  var patronListeners = [];
  window.BeneosSearch = {
    init: init,
    setPatronState: function (o) {
      var next = !!(o && o.battlemapActive);
      if (patronActive === next) return;
      patronActive = next;
      patronListeners.forEach(function (fn) { try { fn(); } catch (e) {} });
    }
  };

  function init(root, cfg) {
    if (!root || root._beneosInit) return;
    root._beneosInit = true;
    cfg = cfg || {};
    var proxyUrl = cfg.proxyUrl || '/apps/beneos/library';
    var locale = cfg.locale || 'en';
    var patreonUrl = cfg.patreonUrl || 'https://www.patreon.com/BeneosBattlemaps';
    var shopUrl = cfg.shopUrl || '/collections/all';
    // "Owned forever": permanently-owned (a real purchase/keep, source purchase/shopify/
    // loyalty/gift), shown as a distinct gold marker so even patrons instantly see what they
    // keep regardless of their Patreon membership. Label localized via the host data attribute.
    // Short label on purpose: this chip sits on top of a card thumbnail and the
    // old "Owned forever" wording was the widest of the set. The full promise
    // moved into the tooltip. data-l-owned-forever stays as a fallback so an
    // older section markup keeps rendering a sensible label.
    var OWNED_FOREVER = cfg.ownedLabel || la('data-l-chip-owned', null)
      || (root.getAttribute && root.getAttribute('data-l-owned-forever')) || T('search.perm_owned', 'Owned');
    function ownedForeverChip() {
      return '<span class="perm-chip owned-forever compact" title="' + esc(TIP_OWNED) + '">' + SVG.check + ' ' + esc(OWNED_FOREVER) + '</span>';
    }
    // Battlemap card chips (localized, English fallback): Free pack (green), Patreon (active
    // tier access, not bought), Premium (no access, needs Patreon or purchase). "Owned forever"
    // (a real purchase/keep) is handled above and always wins.
    function la(attr, d) { return (root.getAttribute && root.getAttribute(attr)) || d; }
    var CHIP_FREE = la('data-l-chip-free', T('search.chip_free', 'Free pack'));
    var CHIP_PATREON = la('data-l-chip-patreon', T('search.chip_patreon', 'Patreon'));
    var CHIP_PREMIUM = la('data-l-chip-premium', T('search.chip_premium', 'Premium'));
    // Each chip states WHY the content is open in one sentence. Native title
    // attribute, the same mechanism the download markers already use, so this
    // needs no tooltip layer and stays keyboard- and screenreader-reachable.
    var TIP_OWNED = T('search.tip_owned', 'Yours forever. Unlocked on this account for good.');
    var TIP_PATREON = T('search.tip_patreon', 'Unlocked while your Patreon membership is active.');
    var TIP_FREE = T('search.tip_free', 'Free content. No membership or purchase needed.');
    function freeChip() { return '<span class="perm-chip free" title="' + esc(TIP_FREE) + '">' + esc(CHIP_FREE) + '</span>'; }
    function patreonChip() { return '<span class="perm-chip patreon" title="' + esc(TIP_PATREON) + '">' + SVG.check + ' ' + esc(CHIP_PATREON) + '</span>'; }
    function premiumChip() { return '<span class="perm-chip premium">' + esc(CHIP_PREMIUM) + '</span>'; }
    // Group bands for the two battlemap views. Both views used to carry their own
    // copy of this markup; they share it now so they cannot drift apart.
    //
    // The band groups by releaseLockedRank (is_free), NOT by access, so for an
    // active patron the lower band holds content they can already install. Telling
    // them to "become a patron" there is nonsense, so the copy switches: it names
    // what they have and leaves the shop as the only CTA, because buying is the one
    // thing that still changes something (permanent ownership instead of access
    // tied to a running membership). In 'owned' sort the band IS access-based, so
    // it keeps the plain locked wording.
    function accessBandHead(label, count) {
      return '<div class="brw-group-h free"><span class="gh-t">' + esc(label) + '</span><span class="gh-n">' + count + '</span></div>';
    }
    function premiumBandHead(count, ownedMode, lockedLabel) {
      var isPatron = !ownedMode && isPatronAccess();
      var heading = ownedMode ? lockedLabel
        : (isPatron ? T('search.band_patron_h', 'Your Patreon packs') : T('search.band_premium_h', 'Premium packs'));
      var blurb = isPatron
        ? T('search.band_patron_txt', 'All the content your membership unlocks. Buy a pack to keep it forever.')
        : T('search.band_premium_txt', 'Free static maps included. Unlock the full animated pack with a Beneos membership.');
      var joinCta = isPatron ? '' :
        '<a class="btn xs primary" href="' + esc(patreonUrl) + '" target="_blank" rel="noopener">' + esc(T('search.cta_join_patreon', 'Join Patreon')) + '</a>';
      return '<div class="brw-group-h ' + (ownedMode ? 'locked' : 'premium') + (isPatron ? ' has-access' : '') + '">' +
          '<div class="gh-meta"><span class="gh-t">' + esc(heading) + '</span><span class="gh-n">' + count + '</span></div>' +
          '<div class="gh-cta"><span class="gh-cta-txt">' + esc(blurb) + '</span>' +
            joinCta +
            '<a class="btn xs ghost" href="' + esc(shopUrl) + '">' + esc(T('search.cta_browse_shop', 'Browse shop')) + '</a>' +
          '</div>' +
        '</div>';
    }

    // release access chip: owned (gold) > free (green) > patreon (tier) > premium (locked).
    function relPermChip(rr) {
      if (rr && rr.can_download_zip) return ownedForeverChip();
      if (rr && rr.is_free) return freeChip();
      if (rr && rr.can_install) return patreonChip();
      return premiumChip();
    }

    // Plan §13: storefront persists the battlemap-specific toggles per-user via
    // localStorage. Default 4K + Releases view; the auto-switch heuristic flips
    // the view to 'individual' while pinned=false and search or biome filter active.
    var LS_BMAP_RES  = 'beneos-bmap-active-resolution';
    var LS_BMAP_VIEW = 'beneos-bmap-view-mode';
    function lsRead(k, fallback) { try { return window.localStorage.getItem(k) || fallback; } catch (e) { return fallback; } }
    function lsWrite(k, v) { try { window.localStorage.setItem(k, v); } catch (e) {} }

    var state = {
      kind: 'battlemap',
      data: {},          // kind -> array of normalized items
      releases: [],      // Plan §13: data.releases payload from app-proxy
      bundles: [],       // Plan §72: data.bundles payload (install-bundles)
      matrix: null,
      owned: {},         // filename -> { source, cloudId }
      loaded: false,
      filters: {},       // kind -> { facetKey: [values], _range: [lo,hi], _perm: [], _q: '' }
      sort: 'new',
      view: 'grid',
      bmapRes: (lsRead(LS_BMAP_RES, '4K') === 'HD' ? 'HD' : '4K'),
      bmapView: (lsRead(LS_BMAP_VIEW, 'releases') === 'individual' ? 'individual' : 'releases'),
      bmapViewPinned: false,
      visible: PAGE,
      openMenu: null,    // active FacetSelect key
      productCache: {}   // filename -> products result
    };
    // Creatures get a source filter (Beneos Originals vs SRD); both on by default.
    function emptyFilters(kind) { var f = { _perm: [], _q: '' }; if (kind === 'token') f._src = ['srd', 'original']; return f; }
    KIND_ORDER.forEach(function (k) { state.filters[k] = emptyFilters(k); });

    root.classList.add('beneos-search');
    root.innerHTML = '<div class="brw-loading">Loading the Beneos library…</div>';

    function loc(path, v) { return window.BeneosDB.localizeLabel(state.matrix, path, v, locale); }
    // ownership join: mirror the Foundry module (lowercase, hyphens -> underscores)
    function normKey(k) { return String(k == null ? '' : k).toLowerCase().replace(/-/g, '_'); }
    // facet value for display: localize, then title-case all-lowercase raw values (e.g. "beast" -> "Beast")
    function dispVal(path, v) {
      var s = path ? loc(path, v) : v;
      if (typeof s === 'string' && /^[a-z][a-z0-9 _\/-]*$/.test(s)) return s.replace(/\b([a-z])/g, function (m, c) { return c.toUpperCase(); });
      return s;
    }
    function typeStr(p) { var t = p.type; return Array.isArray(t) ? t.join(', ') : (t || ''); }

    function thumbFor(kind, props) {
      var f = props[FACETS[kind].thumbField] || props.thumbnail || props.icon;
      return f ? window.BeneosDB.thumbUrl(kind, f) : null;
    }

    function normalize(kind, content) {
      var out = [];
      Object.keys(content).forEach(function (key) {
        var e = content[key]; if (!e) return;
        var p = e.properties || {};
        var ent = state.owned[normKey(key)];
        // Published-gate: hide catalog entries not assigned to any tier yet.
        // Owned assets (ent) always pass; battlemaps are gated elsewhere.
        if (!ent && (kind === 'token' || kind === 'item' || kind === 'spell') &&
            state.publishedSet && state.publishedSet[kind] &&
            !state.publishedSet[kind][normKey(key)]) {
          return;
        }
        // Battlemap publish-gate: a scene of a release that is not published
        // yet is dropped unconditionally, without the owned-bypass above. A
        // draft is never sold or granted, so nobody can own one, and the two
        // key-spaces (catalog entry key vs release id) would not match anyway.
        if (kind === 'battlemap' && state.unpublishedSet && state.unpublishedSet[normKey(key)]) {
          return;
        }
        // Free status, single source of truth: token/item/spell come SOLELY from
        // the cloud "Free" tier (state.freeSet). The catalog free_content flag is
        // deliberately ignored for them (it is stale/unmaintained and must have no
        // effect). Battlemaps keep their own catalog free_content, which IS kept
        // current via the admin Free-Content checkbox.
        var isFreeAsset;
        if (kind === 'battlemap') isFreeAsset = (p.free_content === true);
        else isFreeAsset = !!(state.freeSet && state.freeSet[kind] && state.freeSet[kind][normKey(key)]);
        var perm = ent ? ent.source : (isFreeAsset ? 'free' : 'locked');
        out.push({
          key: key, kind: kind,
          name: e.name || key,
          desc: e.description || p.shortdesc || '',
          props: p,
          perm: perm,
          ownedPerm: ent ? !!ent.ownedPerm : false,
          cloudId: ent ? ent.cloudId : null,
          // Phase 4.6: pass through the per-asset paywall flags. Defaults are permissive so
          // legacy code paths (tokens/items/spells without explicit flags) never lose download.
          canDownloadZip: ent ? (ent.canDownloadZip !== false) : (perm === 'free' || perm === 'shop' || perm === 'backlog'),
          canInstall:     ent ? (ent.canInstall !== false) : (perm !== 'locked'),
          thumb: thumbFor(kind, p),
          // Source bucket for the Originals/SRD filter. Mirrors the Foundry
          // module's BeneosUtility.getSourceBucket: explicit properties.source,
          // else an "srd" segment in the key (e.g. 000-srd_aboleth) -> SRD.
          srd: kind === 'token' && (String(p.source || '').toUpperCase() === 'SRD' || /(?:^|[-_])srd[-_]/i.test(key)),
          cr: kind === 'token' ? crToNum(p.cr) : null,
          price: kind === 'item' ? priceToNum(p.price) : null,
          // release number, kept for grouping and as a tie-break
          rel: (parseInt(window.BeneosDB.releaseOf(key, p.pack), 10) || 0),
          // Recency is the catalog release_date, not the release number: for creatures, loot
          // and spells that number is only the leading digits of the key, so it ranked by key
          // order and called the wrong assets new. All four catalogs carry the date.
          date: String(p.release_date || ''),
          // hidden_tags can be an array OR a comma-string in the public DB; always normalize to an array
          tags: Array.isArray(p.hidden_tags) ? p.hidden_tags
            : (p.hidden_tags ? String(p.hidden_tags).split(',').map(function (s) { return s.trim(); }).filter(Boolean) : [])
        });
      });
      return out;
    }

    function permRank(perm) { return perm === 'locked' ? 1 : 0; } // accessible first

    // A "free account" has no paid access at all: every owned asset is source
    // 'free', and no release exposes a non-free available download (Patreon/shop
    // ZIPs). Drives the extra-green free highlighting (free-account only).
    // Does this account reach non-free releases through an ACTIVE Patreon tier?
    // Only used when the Patreon strip has not reported in (network hiccup, or a
    // page that renders the browser without the hero). can_download_zip !== true
    // is the load-bearing part: it excludes permanent ownership, so a pure shop
    // buyer (own release: can_download_zip true; everything else: can_install
    // false) is correctly NOT read as a patron, while a tier patron matches on
    // every release they have not bought.
    function derivePatronAccess() {
      return (state.releases || []).some(function (r) {
        return r && !r.is_free && r.can_install === true && r.can_download_zip !== true;
      });
    }
    function isPatronAccess() {
      return patronActive === null ? derivePatronAccess() : patronActive;
    }

    function computeIsFreeAccount() {
      // Note: battlemap owned entries are NOT a paid signal, the app-proxy
      // defaults their source to 'patreon' even for free users. We rely on
      // state.ownedHasPaid (token/item/spell only) + release availability.
      if (state.ownedHasPaid) return false;
      var rel = state.releases || [];
      for (var i = 0; i < rel.length; i++) {
        var dls = (rel[i] && rel[i].available_downloads) || [];
        for (var j = 0; j < dls.length; j++) {
          var d = dls[j];
          if (d && d.state !== 'locked' && d.source && d.source !== 'free') return false;
        }
      }
      return true;
    }

    // ---------- data load ----------
    function ownedFromLibrary(j) {
      var d = (j && j.data) || {};
      var map = {};
      // Track, per content type, whether the owned set has any / any new / any updated assets,
      // so the bulk-download select only offers modes that actually deliver something.
      var avail = {
        token: { any: false, new: false, updated: false },
        spell: { any: false, new: false, updated: false },
        item: { any: false, new: false, updated: false },
        battlemap: { any: false, new: false, updated: false }
      };
      var g2k = { tokens: 'token', spells: 'spell', items: 'item', battlemaps: 'battlemap' };
      // Paid-access signal for the free-account flag: any owned token/item/spell
      // with a non-free source. Battlemaps are excluded (their source defaults to
      // 'patreon' in the proxy even for free users, so they are not reliable).
      var paidNonBmap = false;
      Object.keys(g2k).forEach(function (grp) {
        var arr = d[grp];
        if (!Array.isArray(arr)) return; // tolerate a malformed/old proxy shape
        var kind = g2k[grp];
        arr.forEach(function (a) {
          var k = a.key || a.filename; if (!k) return;
          if (grp !== 'battlemaps' && a.source && a.source !== 'free') paidNonBmap = true;
          map[normKey(k)] = {
            // Ungekuerzter Cloud-Schluessel. normKey() verbiegt Schreibweise und
            // Bindestriche fuer den Abgleich mit dem Katalog; der Bulk-Download
            // muss aber genau den Wert schicken, den die Cloud kennt.
            key: k,
            source: a.source || 'backlog',
            cloudId: a.cloudId || a.id || null,
            // "Du hast es geladen und es hat sich seither geaendert." Kommt aus dem
            // Signaturvergleich der Cloud. Bewusst NICHT isUpdated: das haengt am
            // Zeitstempel der Datenbankzeile und markiert deshalb fast alles.
            needsUpdate: a.needs_update === true,
            // Phase 4.6: battlemap cards need a per-asset gate because Patreon-active users
            // get install access but not the raw ZIP. Tokens/items/spells keep the default
            // true so they never lose download access.
            canDownloadZip: (a.can_download_zip === undefined) ? true : !!a.can_download_zip,
            canInstall:     (a.can_install === undefined) ? true : !!a.can_install,
            // "Owned forever": ledger-permanent (purchase/shopify/loyalty/gift). Battlemaps
            // signal it via can_download_zip (tier access never sets it); other types carry
            // the explicit owned_permanent flag from the proxy.
            ownedPerm: (a.owned_permanent === true) || (kind === 'battlemap' && a.can_download_zip === true),
          };
          avail[kind].any = true;
          if (a.isNew) avail[kind].new = true;
          if (a.isUpdated) avail[kind].updated = true;
        });
      });
      state.bulkAvail = avail;
      state.ownedHasPaid = paidNonBmap;
      return map;
    }

    Promise.all([
      window.BeneosDB.load('token').catch(function () { return {}; }),
      window.BeneosDB.load('battlemap').catch(function () { return {}; }),
      window.BeneosDB.load('spell').catch(function () { return {}; }),
      window.BeneosDB.load('item').catch(function () { return {}; }),
      (locale === 'en') ? Promise.resolve(null) : window.BeneosDB.load('i18n').catch(function () { return null; }),
      fetch(proxyUrl, { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' }).then(function (r) { return r.json(); }).catch(function () { return null; })
    ]).then(function (res) {
      state.matrix = res[4];
      try { state.owned = res[5] ? ownedFromLibrary(res[5]) : {}; }
      catch (e) { console.error('[beneos-search] ownedFromLibrary failed', e); state.owned = {}; }
      // Plan §19.5 — state.releases now carries per-release available_downloads
      // payloads from app-proxy.php. Each item: {cloud_release_id, release_dir,
      // display_name, release_num, scene_count, cover_url, available_downloads}.
      // Indexed by release_dir so the drawer can look up the parent release
      // when the user clicks an individual battlemap-catalog entry.
      try {
        var releaseList = (res[5] && res[5].data && Array.isArray(res[5].data.releases)) ? res[5].data.releases : [];
        state.releases = releaseList;
        state.releaseByDir = {};
        state.releaseById = {};
        releaseList.forEach(function (r) {
          if (!r) return;
          if (r.release_dir) state.releaseByDir[r.release_dir] = r;
          if (r.cloud_release_id) state.releaseById[r.cloud_release_id] = r;
        });
      } catch (e) {
        console.error('[beneos-search] releases parse failed', e);
        state.releases = []; state.releaseByDir = {}; state.releaseById = {};
      }
      // Plan §72.4 - load install-bundles into state for the Bundles tab.
      try {
        var bundleList = (res[5] && res[5].data && Array.isArray(res[5].data.bundles)) ? res[5].data.bundles : [];
        state.bundles = bundleList;
        state.bundleById = {};
        bundleList.forEach(function (b) { if (b && b.id) state.bundleById[b.id] = b; });
      } catch (e) {
        console.error('[beneos-search] bundles parse failed', e);
        state.bundles = []; state.bundleById = {};
      }
      // Published-asset allowlist (app-proxy data.published, filename-keyed per
      // type). The public catalog is loaded in full client-side; this set lets
      // normalize() drop catalog entries that are not assigned to any tier yet
      // (= not published). Owned assets bypass the gate so reward/loyalty/shop
      // assets that carry no asset_tiers row are never hidden.
      try {
        var pub = (res[5] && res[5].data && res[5].data.published) ? res[5].data.published : null;
        state.publishedSet = null;
        if (pub) {
          state.publishedSet = {};
          ['token', 'item', 'spell'].forEach(function (k) {
            var map = {};
            (Array.isArray(pub[k]) ? pub[k] : []).forEach(function (fn) { map[normKey(fn)] = true; });
            state.publishedSet[k] = map;
          });
        }
      } catch (e) {
        console.error('[beneos-search] published parse failed', e);
        state.publishedSet = null;
      }
      // Battlemaps run the other way round: the catalog holds several thousand
      // entries, so an allowlist would blow up the payload. The server sends a
      // deny-list of the scenes belonging to a release that is not published
      // yet. Empty or missing = nothing to hide (admins get it empty on purpose,
      // so they can preview a prepared release).
      try {
        var unp = (res[5] && res[5].data && res[5].data.unpublished) ? res[5].data.unpublished.battlemap : null;
        state.unpublishedSet = {};
        (Array.isArray(unp) ? unp : []).forEach(function (k) { state.unpublishedSet[normKey(k)] = true; });
      } catch (e) {
        console.error('[beneos-search] unpublished parse failed', e);
        state.unpublishedSet = {};
      }
      // Free allowlist (data.free) — the dynamic source of truth for free status,
      // driven by the cloud "Free" tier. Replaces the static catalog free_content
      // flag so admin tier changes take effect immediately (catalog flag is only a
      // fallback when the cloud free list is absent).
      try {
        var fre = (res[5] && res[5].data && res[5].data.free) ? res[5].data.free : null;
        state.freeSet = null;
        if (fre) {
          state.freeSet = {};
          ['token', 'item', 'spell'].forEach(function (k) {
            var map = {};
            (Array.isArray(fre[k]) ? fre[k] : []).forEach(function (fn) { map[normKey(fn)] = true; });
            state.freeSet[k] = map;
          });
        }
      } catch (e) {
        console.error('[beneos-search] free parse failed', e);
        state.freeSet = null;
      }
      // one bad content kind must not blank the whole library
      function norm(kind, content) {
        try { return normalize(kind, content); }
        catch (e) { console.error('[beneos-search] normalize ' + kind + ' failed', e); return []; }
      }
      state.data.token = norm('token', res[0]);
      state.data.battlemap = norm('battlemap', res[1]);
      state.data.spell = norm('spell', res[2]);
      state.data.item = norm('item', res[3]);
      // Free account = no paid access anywhere: no owned asset with a non-free
      // source AND no release exposing a non-free available download. Used to
      // turn on the extra-green free highlighting (free users benefit most from
      // seeing at a glance what is actually free for them).
      state.isFreeAccount = computeIsFreeAccount();
      state.loaded = true;
      buildShell();
      render();
      // Gespeicherte Teile-Laeufe von vor der Umstellung wegraeumen. Der Server liefert
      // seit 2026-08-04 ein Archiv statt vier Teilen; ein alter Lauf haette sonst noch
      // 24 Stunden lang ein Fenster ohne Schliessen-Knopf stehen lassen.
      verlaufAltbestandRaeumen();
      // Lief beim Neuladen gerade ein Download, kommt das Symbol samt Takt zurueck.
      if (aktivLesen()) fortschrittTakt();
      // A late Patreon-strip response flips the premium band's copy + CTA, so
      // re-render when it lands after the first paint.
      patronListeners.push(function () { if (state.loaded) render(); });
    }).catch(function (err) {
      console.error('[beneos-search] init failed', err);
      root.innerHTML = '<div class="brw-loading">The library is temporarily unavailable. Please try again.</div>';
    });

    // ---------- filtering ----------
    function facetValues(item, sel) {
      var v = item.props[sel.key];
      if (v == null || v === '') return [];
      // DB multi-value fields arrive as real arrays (e.g. type ['beast','dinosaur']);
      // always split arrays, and split comma-joined strings for multi-value facets.
      var arr = Array.isArray(v) ? v : (sel.arr ? String(v).split(/\s*,\s*/) : [v]);
      return arr.map(function (x) { return x == null ? '' : String(x).trim(); })
        .filter(function (x) { return x && x.toLowerCase() !== 'none'; });
    }
    function filtered() {
      var items = state.data[state.kind] || [];
      var f = state.filters[state.kind];
      var fdef = FACETS[state.kind];
      var q = (f._q || '').toLowerCase();
      // Plan §19.5 Phase A2 — Individual-Maps is rendered by a dedicated
      // branch in renderResults() that flattens state.releases[].scenes; the
      // generic filtered() path is no longer reached for that view. The old
      // bmList-level filter was a dead-end because bmList carries one row per
      // release-asset (no scene-level entries and no parent-release key).
      var res = items.filter(function (it) {
        if (f._perm && f._perm.length) {
          var has = f._perm.indexOf('owned') !== -1 ? it.perm !== 'locked' : false;
          var lock = f._perm.indexOf('locked') !== -1 ? it.perm === 'locked' : false;
          if (!(has || lock)) return false;
        }
        // Creatures: Beneos Originals vs SRD. Both on (default) -> no effect.
        if (state.kind === 'token' && f._src && f._src.length < 2) {
          if (it.srd && f._src.indexOf('srd') === -1) return false;
          if (!it.srd && f._src.indexOf('original') === -1) return false;
        }
        if (q) {
          var hay = (it.name + ' ' + (it.tags || []).join(' ')).toLowerCase();
          if (hay.indexOf(q) === -1) return false;
        }
        if (fdef.range && f._range) {
          var num = state.kind === 'item' ? it.price : it.cr;
          var lo = f._range[0], hi = f._range[1];
          if (!(lo === 0 && hi === fdef.range.max)) {
            if (num == null || num < lo || num > hi) return false;
          }
        }
        for (var i = 0; i < fdef.selects.length; i++) {
          var sel = fdef.selects[i]; var want = f[sel.key];
          if (!want || !want.length) continue;
          var vals = facetValues(it, sel);
          var ok = false; for (var j = 0; j < want.length; j++) { if (vals.indexOf(want[j]) !== -1) { ok = true; break; } }
          if (!ok) return false;
        }
        return true;
      });
      var cmp;
      if (state.sort === 'name' || state.sort === 'owned') cmp = function (a, b) { return a.name.localeCompare(b.name); };
      else if (state.sort === 'cr')    cmp = function (a, b) { return cmpNullsLast(rankValue(a), rankValue(b)) || a.name.localeCompare(b.name); };
      else                             cmp = function (a, b) { // 'new': newest release_date first, number then name as tie-breaks
        return (b.date || '').localeCompare(a.date || '') || (b.rel || 0) - (a.rel || 0) || a.name.localeCompare(b.name);
      };
      // Free/accessible content is always grouped above locked (mirrors the
      // Foundry module: free on top, locked shop/patreon in red below). The
      // selected sort orders within each group.
      res.sort(function (a, b) { return permRank(a.perm) - permRank(b.perm) || cmp(a, b); });
      return res;
    }

    // collect distinct values for a select (with counts), localized
    function optionsFor(sel) {
      var counts = {};
      if (state.kind === 'battlemap') {
        // Battlemaps filter at release granularity. The dropdown options come
        // from the release-level facet sets the backend aggregates from the
        // catalog (release.facets: biom/adventure/type/brightness/grid — the
        // same fields the Foundry module filters on). The per-scene fields are
        // unreliable (catalog<->.scenes slug mismatch), so they are not used.
        // count = number of releases offering the value.
        (state.releases || []).forEach(function (r) {
          var fac = (r && r.facets) || {};
          var v = fac[sel.key];
          (Array.isArray(v) ? v : []).forEach(function (x) {
            x = (x == null ? '' : String(x)).trim();
            if (x && x.toLowerCase() !== 'none') counts[x] = (counts[x] || 0) + 1;
          });
        });
      } else {
        var items = state.data[state.kind] || [];
        items.forEach(function (it) { facetValues(it, sel).forEach(function (v) { counts[v] = (counts[v] || 0) + 1; }); });
      }
      return Object.keys(counts).sort(function (a, b) {
        if (sel.key === 'level' || sel.key === 'tier') { var na = parseFloat(a), nb = parseFloat(b); if (!isNaN(na) && !isNaN(nb)) return na - nb; }
        return a.localeCompare(b);
      }).map(function (v) { return { value: v, label: dispVal(sel.path, v), count: counts[v] }; });
    }

    // ---------- shell ----------
    function buildShell() {
      root.innerHTML =
        // Die Tabs sassen frueher rechts neben der Ueberschrift in derselben
        // umbrechenden Zeile. Bei "The animated battlemaps library." ist der Titel zu
        // lang, also rutschten sie eine Zeile tiefer, und die Leiste sprang je nach
        // Kategorie. Sie haben jetzt ein eigenes Band unter der Ueberschrift und
        // stehen dadurch auf allen vier Tabs an derselben Stelle.
        '<div class="page-head"><div class="ph-l">' +
          '<div class="ph-eyebrow" data-eyebrow></div>' +
          '<h1>' + T('search.lib_title_html', 'The <em data-kindname></em> library.') + '</h1>' +
          // Die Trefferzahl ist Information, kein Bedienelement. Sie stand bisher in
          // der Werkzeugleiste und machte sie unruhig; dieser Platz war leer.
          '<div class="ph-sub count" data-count></div>' +
        '</div></div>' +
        '<div class="ph-tabs" data-tabs role="tablist"></div>' +
        '<div class="brw"><aside class="brw-side" data-side></aside><div class="brw-main">' +
          '<div class="brw-toolbar">' +
            '<div class="brw-search"><span class="sicon" aria-hidden="true">' + SVG.search + '</span><input type="search" data-q aria-label="' + esc(T('search.search_label', 'Search this library')) + '"></div>' +
            '<div class="brw-tools">' +
            '<span class="brw-toollabel" id="bn-sortlab">' + esc(T('search.sort_label', 'Sort')) + '</span>' +
            '<select class="select" data-sort aria-labelledby="bn-sortlab"><option value="new">' + esc(T('search.sortopt_new', 'New & updated')) + '</option><option value="owned">' + esc(T('search.sortopt_access', 'Your access first')) + '</option><option value="name">' + esc(T('search.sortopt_name', 'Name A-Z')) + '</option><option value="cr">' + esc(T('search.sortopt_map_size', 'Map size')) + '</option></select>' +
            '<span class="spacer"></span>' +
            '<select class="select brw-bulk" data-bulk hidden title="' + esc(T('search.own_hint', 'Download the assets you own in this category')) + '"><option value="">' + esc(T('search.bulk_download', 'Bulk download…')) + '</option></select>' +
            // Verlauf: draengt sich nicht auf, ist aber erreichbar. Oeffnet sich sonst nur
            // von selbst, wenn ein Download abgebrochen ist und ein Neustart ansteht.
            '<button type="button" class="select brw-dlhist" data-dlhist hidden title="' + esc(T('search.dl_history', 'Your recent downloads')) + '" aria-label="' + esc(T('search.dl_history', 'Your recent downloads')) + '">↧</button>' +
            /* Plan §13: bmap-only toolbar segments. Sandwiched between Sort and
               the Grid/List toggle. Hidden via the `hidden` attribute when the
               active kind is not battlemap. */
            /* Storefront-only: tier-zips are single-variant per release,
               so the 4K/HD resolution toggle is irrelevant here. Only the
               Releases / Individual-Maps switch survives. */
            '<div class="brw-bmap-toolbar"' + (state.kind === 'battlemap' ? '' : ' hidden') + '>' +
              '<div class="brw-viewseg" data-bmap-view>' +
                '<button data-bmap-view-val="releases"' + (state.bmapView === 'releases' ? ' class="active"' : '') + '>Releases</button>' +
                '<button data-bmap-view-val="individual"' + (state.bmapView === 'individual' ? ' class="active"' : '') + '>Individual Maps</button>' +
                ((state.bundles && state.bundles.length) ? '<button data-bmap-view-val="bundles"' + (state.bmapView === 'bundles' ? ' class="active"' : '') + '>Bundles</button>' : '') +
              '</div>' +
            '</div>' +
            '<div class="brw-viewseg"><button data-view="grid" class="active">' + SVG.grid + ' Grid</button><button data-view="list">' + SVG.list + ' List</button></div>' +
            '</div>' +
          '</div>' +
          '<div class="brw-active" data-active></div>' +
          '<div data-results></div>' +
          '<div class="load-more" data-more></div>' +
        '</div></div>' +
        '<div data-modal></div>';

      // tabs
      var tabsEl = root.querySelector('[data-tabs]');
      tabsEl.innerHTML = KIND_ORDER.map(function (k) {
        var aktiv = (k === state.kind);
        // Name und Zahl untereinander: der Name traegt die Aussage, die Zahl steht
        // kleiner und weiter gesperrt darunter. Zurueckgenommen wird ueber Groesse
        // und Laufweite, nicht ueber Kontrast (DESIGN.md, Quiet Without Dimming).
        return '<button type="button" role="tab" aria-selected="' + (aktiv ? 'true' : 'false') + '"'
          + ' data-tab="' + k + '"' + (aktiv ? ' class="active"' : '') + '>'
          + '<span class="t">' + esc(FACETS[k].tab) + '</span>'
          + '<span class="n">' + (state.data[k] ? state.data[k].length : 0) + '</span>'
          + '</button>';
      }).join('');
      tabsEl.addEventListener('click', function (e) {
        var b = e.target.closest('[data-tab]'); if (!b) return;
        state.kind = b.getAttribute('data-tab'); state.visible = PAGE; state.openMenu = null;
        /* Plan §13: hide the bmap-only toolbar on non-bmap tabs. */
        var tb = root.querySelector('.brw-bmap-toolbar');
        if (tb) { if (state.kind === 'battlemap') tb.removeAttribute('hidden'); else tb.setAttribute('hidden', ''); }
        render();
      });

      /* Plan §13: bmap toolbar handlers. Resolution persists, view-mode pins on click. */
      var bmapTb = root.querySelector('.brw-bmap-toolbar');
      if (bmapTb) {
        bmapTb.addEventListener('click', function (e) {
          var res = e.target.closest('[data-bmap-res-val]');
          if (res) {
            var v = res.getAttribute('data-bmap-res-val');
            if (v !== '4K' && v !== 'HD') return;
            state.bmapRes = v;
            lsWrite(LS_BMAP_RES, v);
            Array.prototype.forEach.call(root.querySelectorAll('[data-bmap-res-val]'), function (x) { x.classList.toggle('active', x === res); });
            renderResults();
            return;
          }
          var view = e.target.closest('[data-bmap-view-val]');
          if (view) {
            var w = view.getAttribute('data-bmap-view-val');
            if (w !== 'releases' && w !== 'individual' && w !== 'bundles') return;
            state.bmapView = w;
            state.bmapViewPinned = true;
            lsWrite(LS_BMAP_VIEW, w);
            Array.prototype.forEach.call(root.querySelectorAll('[data-bmap-view-val]'), function (x) { x.classList.toggle('active', x === view); });
            state.visible = PAGE;
            updateSortLabels();
            renderSidebar(); // access counts follow the active view
            renderResults();
          }
        });
      }

      root.querySelector('[data-q]').addEventListener('input', debounce(function (e) {
        state.filters[state.kind]._q = e.target.value; state.visible = PAGE; renderResults(); renderActive();
      }, 180));
      root.querySelector('[data-sort]').addEventListener('change', function (e) { state.sort = e.target.value; renderResults(); });
      root.querySelector('[data-bulk]').addEventListener('change', function (e) { var mode = e.target.value; e.target.selectedIndex = 0; if (mode) doBulkDownload(mode); });
      root.querySelector('[data-dlhist]').addEventListener('click', function () { verlaufAnzeigen(); });
      root.querySelector('[data-view]').parentNode.addEventListener('click', function (e) {
        var b = e.target.closest('[data-view]'); if (!b) return; state.view = b.getAttribute('data-view'); renderResults();
        Array.prototype.forEach.call(root.querySelectorAll('[data-view]'), function (x) { x.classList.toggle('active', x === b); });
      });
      // Click fallback for the no-IntersectionObserver path (renderMore only
      // emits a button then). The infinite-scroll observer itself is managed in
      // renderMore so it re-arms on a FRESH sentinel each render.
      root.querySelector('[data-more]').addEventListener('click', function (e) { if (e.target.closest('button')) { state.visible += PAGE; renderResults(); } });

      // delegated clicks for cards/sidebar
      root.addEventListener('click', onClick);

      // The online Creature Codex (beneos.cloud, opened in a new tab) can ask us
      // to search for a recommended ally. Fill the free-text search, jump to the
      // Creatures tab, and surface the result in this still-open library tab.
      window.addEventListener('message', function (e) {
        if (e.origin !== 'https://beneos.cloud') return;
        var d = e.data || {};
        if (d.type !== 'beneos-codex-ally-search' || !d.q) return;
        state.kind = 'token';
        if (!state.filters.token) state.filters.token = emptyFilters('token');
        state.filters.token._q = String(d.q);
        state.visible = PAGE;
        var qi = root.querySelector('[data-q]');
        if (qi) qi.value = String(d.q);
        render();
        try { root.scrollIntoView({ behavior: 'smooth', block: 'start' }); } catch (x) {}
        try { window.focus(); } catch (x) {}
      });
    }

    function debounce(fn, ms) { var t; return function () { var a = arguments, c = this; clearTimeout(t); t = setTimeout(function () { fn.apply(c, a); }, ms); }; }

    // The 4th sort option is kind-specific; its label follows the active tab
    // (and the battlemap view) so "CR" never shows up on the Items tab.
    // Ohne "Sort · " davor: das steht jetzt als eigene Beschriftung neben dem Feld,
    // statt in jeder einzelnen Option zu stecken.
    function sortOpt4Label() {
      if (state.kind === 'token') return T('search.sortopt_cr', 'Challenge rating');
      if (state.kind === 'spell') return T('search.sortopt_spell_level', 'Spell level');
      if (state.kind === 'item') return T('search.sortopt_gold', 'Gold price');
      return state.bmapView === 'bundles' ? T('search.sortopt_bundle_size', 'Bundle size') : T('search.sortopt_map_size', 'Map size');
    }
    function updateSortLabels() {
      var s = root.querySelector('[data-sort]');
      if (s && s.options[3]) s.options[3].text = sortOpt4Label();
    }

    // ---------- render ----------
    function render() {
      // Free-account marker drives the extra-green free highlighting (CSS).
      root.classList.toggle('free-account', !!state.isFreeAccount);
      // tab active state + counts
      Array.prototype.forEach.call(root.querySelectorAll('[data-tab]'), function (b) {
        var an = b.getAttribute('data-tab') === state.kind;
        b.classList.toggle('active', an);
        b.setAttribute('aria-selected', an ? 'true' : 'false');
      });
      root.querySelector('[data-eyebrow]').textContent = T('search.eyebrow', 'Asset library') + ' · ' + FACETS[state.kind].tab;
      root.querySelector('[data-kindname]').textContent = FACETS[state.kind].tab.toLowerCase();
      // Der Platzhalter nennt den Bestand, in dem gesucht wird. Vorher stand dort hart
      // "Search…" auf Englisch, also in allen 13 Sprachen englisch.
      var qEl = root.querySelector('[data-q]');
      if (qEl) {
        qEl.setAttribute('placeholder', T('search.search_ph', 'Search {{count}} {{kind}}…')
          .replace('{{count}}', String((state.data[state.kind] || []).length))
          .replace('{{kind}}', FACETS[state.kind].tab.toLowerCase()));
      }
      updateSortLabels(); updateBulk(); renderSidebar(); renderActive(); renderResults();
    }

    // discreet bulk download of the assets you own in the current category (web users who
    // can't install via Foundry get one file instead of hundreds of single downloads).
    // Only for token/spell/item (maps = phase 2) and only when you actually own some.
    function updateBulk() {
      var el = root.querySelector('[data-bulk]');
      if (!el) return;
      var hist = root.querySelector('[data-dlhist]');
      var kind = state.kind;
      var avail = state.bulkAvail && state.bulkAvail[kind];
      // maps get no bulk option yet (phase 2); only show when the user actually owns some of this type
      var canBulk = (kind === 'token' || kind === 'spell' || kind === 'item') && avail && avail.any;
      // Der Verlaufsknopf haengt an derselben Bedingung: wer hier nichts laden kann, hat
      // auch keinen Verlauf, den dieses Fenster zeigen wuerde.
      if (hist) hist.hidden = !canBulk;
      if (!canBulk) { el.hidden = true; el.innerHTML = ''; return; }
      // Beide Zahlen zaehlen ueber denselben Besitzstand, den die Cloud beim Download
      // aufloest, und folgen dem aktiven Filter. Bis 2026-08-04 stand hier eine Zahl aus
      // der Bibliotheksliste, waehrend der Download seinen Besitz anders aufloeste; das
      // Menue versprach dadurch 494 und lieferte 28.
      var alle  = ownedFilteredKeys();
      var offen = ownedFilteredKeys(true);
      // Ohne Filter heisst der Eintrag ehrlich "alles", mit Filter "was du siehst".
      var gefiltert = false;
      try { gefiltert = filtered().length !== (state.data[state.kind] || []).length; } catch (e) { gefiltert = false; }
      var alleLabel = gefiltert
        ? T('search.bulk_all', 'Download shown')
        : T('search.bulk_everything', 'Download all');

      var opts = '<option value="">' + esc(T('search.bulk_download', 'Bulk download…')) + '</option>';
      if (alle.length > 0) {
        opts += '<option value="all">' + esc(alleLabel) + ' (' + alle.length + ')</option>';
      }
      // "Download new" faellt weg: es hiess "vor weniger als 30 Tagen angelegt" und waere
      // neben dem kontobezogenen "updated" eine zweite, andere Rechnung.
      if (offen.length > 0) {
        opts += '<option value="updated">' + esc(T('search.bulk_updated', 'Download updated')) + ' (' + offen.length + ')</option>';
      }
      el.innerHTML = opts;
      el.hidden = false;
      el.selectedIndex = 0;
    }

    // Cloud-Schluessel der Assets, die der Nutzer besitzt UND die gerade sichtbar sind.
    // Mit nurAenderungen nur die, die er geladen hat und die sich seither geaendert haben.
    function ownedFilteredKeys(nurAenderungen) {
      if (state.kind !== 'token' && state.kind !== 'spell' && state.kind !== 'item') return [];
      var out = [];
      try {
        filtered().forEach(function (it) {
          var own = state.owned[normKey(it.key)];
          if (!own || !own.key) return;
          if (nurAenderungen && !own.needsUpdate) return;
          out.push(own.key);
        });
      } catch (e) { return []; }
      return out;
    }

    function fmtBytes(n) {
      n = Number(n) || 0;
      if (n <= 0) return '';
      var u = ['B', 'KB', 'MB', 'GB'], i = 0, v = n;
      while (v >= 1024 && i < u.length - 1) { v /= 1024; i++; }
      return ((v >= 10 || i === 0) ? Math.round(v) : v.toFixed(1)) + ' ' + u[i];
    }

    function doBulkDownload(mode) {
      var el = root.querySelector('[data-bulk]');
      function lock() { if (el) el.setAttribute('disabled', 'disabled'); }
      function release() { if (el) { el.removeAttribute('disabled'); el.selectedIndex = 0; } }
      lock();

      // Beide Modi schicken die gefilterte Trefferliste mit, damit der Download genau
      // das liefert, was im Menue stand. Die Liste ist eine Einschraenkung, keine
      // Freischaltung: die Cloud prueft Besitz und Aenderungsstand ohnehin erneut.
      var body = null;
      if (mode === 'all' || mode === 'updated') {
        var keys = ownedFilteredKeys(mode === 'updated');
        if (!keys.length) { toast(T('search.dl_empty', 'Nothing to download in this view.')); release(); return; }
        body = JSON.stringify({ keys: keys });
      }
      toast(T('search.dl_preparing', 'Preparing your download, this can take a moment…'));

      var opts = { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' };
      if (body) {
        opts.method = 'POST';
        opts.body = body;
        opts.headers['Content-Type'] = 'application/json';
      }
      fetch(withParam(proxyUrl, 'resource=download_bulk&asset_type=' + encodeURIComponent(state.kind) + '&mode=' + encodeURIComponent(mode)), opts)
        .then(function (r) { return r.json(); })
        .then(function (j) {
          if (j && j.result === 'BUSY') {
            // drei Gruende: eigener Download laeuft, kurze Nachlauffrist, oder alle
            // Slots des Servers sind belegt. Der letzte Fall liegt nicht am Konto.
            toast(busyText(j));
            release();
            return;
          }
          if (!j || j.result !== 'OK' || !j.url) { toast(T('search.dl_failed', 'Download could not be prepared.')); release(); return; }
          var teile = (j.parts && j.parts.length) ? j.parts : [];
          // EINE Meldung, nicht zwei.
          //
          // Es gibt genau ein Meldungsfeld, jeder Aufruf ueberschreibt den vorigen, und
          // es steht 2,2 Sekunden. Vorher liefen Startmeldung und Teile-Hinweis im
          // selben Durchlauf hintereinander, die zweite loeschte die erste im selben
          // Wimpernschlag. Der Kunde bekam von der ganzen Sache einen Satz zu sehen.
          // Deshalb beides in einem Satz, und die bleibende Fassung steht im
          // Downloadverlauf, wo sie auch morgen noch abrufbar ist.
          var meldung = '';
          if (j.count) {
            meldung = T('search.dl_started', 'Starting download')
              + ' (' + j.count + (j.bytes ? ', ' + fmtBytes(j.bytes) : '') + ')';
          }
          if (teile.length > 1) {
            var mengenwort = teile.length + ' ' + T('search.dl_files', 'files');
            meldung = (meldung ? meldung + '. ' : '')
              + T('search.dl_parts_intro', 'Large selection, so it arrives as several files. The next one starts on its own, so keep this page open.')
              + ' (' + mengenwort + ')';
          }
          if (meldung) toast(meldung);
          window.location.href = j.url;
          // Ab hier gehoert der Download dem Browser. Wie weit er ist, meldet der Server;
          // das Symbol unten rechts zeigt es und der Verlauf oeffnet sich von selbst,
          // wenn der Strom stehenbleibt.
          j.name = (j.count ? j.count + ' ' : '') + FACETS[state.kind].tab;
          downloadBegonnen(j);
          release();
        })
        .catch(function () { toast(T('search.dl_failed', 'Download could not be prepared.')); release(); });
    }

    // ---------- Downloadverlauf ----------
    // Kleiner Verlauf statt des frueheren Teile-Fensters. Bis 2026-08-04 kamen grosse
    // Bundles in Teilen zurueck, weil ein zur Laufzeit erzeugtes ZIP keine
    // Range-Anfrage beantworten konnte; seit der Strom fortsetzbar ist, gibt es wieder
    // EIN Archiv, und das Fenster wird zu dem, was der Kunde eigentlich braucht: was
    // habe ich zuletzt geladen, was ist abgebrochen, und wie starte ich es neu.
    //
    // Grenze, die man kennen muss: das Fortsetzen selbst macht der Browser. Reisst die
    // Verbindung, bietet er es von sich aus an und schickt die Range-Anfrage, die der
    // Server beantwortet. Bricht der Kunde absichtlich ab, verwirft der Browser die
    // Teildatei und niemand kann fortsetzen; dann bleibt nur der Neustart von vorn.
    var VERLAUF_ALT_KEY = 'beneos_bulk_run';
    // Laufender Download. Versionsschluessel UND Verfallszeit, gelernt am Teile-Fenster:
    // das lag ohne beides 24 Stunden lang im Speicher und kam nach jedem Neuladen zurueck.
    var AKTIV_KEY = 'beneos_dl_active_v1';
    var verlaufTimer = null;
    var fortschrittTimer = null;
    var verlaufOffen = false;

    function aktivLesen() {
      try {
        var a = JSON.parse(window.localStorage.getItem(AKTIV_KEY) || 'null');
        if (!a || !a.sel || !a.bis || a.bis < Date.now()) { aktivLoeschen(); return null; }
        return a;
      } catch (e) { return null; }
    }
    // Der Eintrag traegt die ganze Warteschlange, nicht nur den laufenden Teil. Sonst
    // waere nach einem Neuladen der Seite nicht mehr bekannt, dass noch ein zweiter
    // Teil aussteht, und der Kunde saesse mit einem halben Bestand da.
    function aktivSetzen(teile, index, name) {
      var i = index || 0;
      var t = (teile && teile[i]) || null;
      if (!t || !t.sel) return;
      try {
        window.localStorage.setItem(AKTIV_KEY, JSON.stringify({
          sel: t.sel, name: name || '', bytes: t.bytes || 0,
          teile: teile, index: i,
          // Laenger als eine halbe Stunde ist kein Download mehr "laufend", sondern ein
          // Rest, den niemand mehr sehen will.
          bis: Date.now() + 30 * 60 * 1000
        }));
      } catch (e) { /* privater Modus */ }
    }

    // "Part 2/3", oder leer bei einem einzigen Teil. Der vorhandene Schluessel
    // dl_part stammt aus der Teile-Zeit vor dem 2026-08-04 und steht in allen
    // dreizehn Sprachen.
    function teilMarke(a) {
      var n = (a && a.teile && a.teile.length) || 1;
      if (n < 2) return '';
      return T('search.dl_part', 'Part') + ' ' + ((a.index || 0) + 1) + '/' + n + '  ·  ';
    }
    function aktivLoeschen() {
      try { window.localStorage.removeItem(AKTIV_KEY); } catch (e) { /* egal */ }
    }

    // Ein gespeicherter Lauf aus der Teile-Zeit haette sonst bis zum Ablauf des Tokens
    // ein Fenster ohne Schliessen-Knopf stehen lassen.
    function verlaufAltbestandRaeumen() {
      try { window.localStorage.removeItem(VERLAUF_ALT_KEY); } catch (e) { /* privater Modus */ }
      var alt = document.querySelector('[data-bulk-parts]');
      if (alt && alt.parentNode) alt.parentNode.removeChild(alt);
      var chip = document.querySelector('[data-bulk-chip]');
      if (chip && chip.parentNode) chip.parentNode.removeChild(chip);
    }

    // Ein Grund, drei Formulierungen. Wird sowohl vom Auswahlfeld als auch vom
    // Verlaufsfenster benutzt, damit derselbe Fall nicht zweimal anders klingt.
    function busyText(busy) {
      var grund = (busy && (busy.reason || busy.information)) || '';
      if (grund === 'bundle_running') {
        return T('search.dl_running', 'A download is already running. Please wait until it finishes.');
      }
      if (grund === 'server_busy') {
        return T('search.dl_server_busy', 'All download slots are busy right now. Please try again in a few minutes.');
      }
      return T('search.dl_wait', 'Please wait a moment before starting the next download.');
    }

    function verlaufHolen(fertig) {
      fetch(withParam(proxyUrl, 'resource=download_history'),
        { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (j) { fertig(j && j.result === 'OK' ? j : null); })
        .catch(function () { fertig(null); });
    }

    function fmtZeit(s) {
      // Der Server liefert "YYYY-MM-DD HH:MM:SS" in seiner Zeitzone. Ohne Umrechnung
      // anzeigen ist ehrlicher als eine falsche Ortszeit vorzutaeuschen.
      if (!s) return '';
      return String(s).replace('T', ' ').slice(0, 16);
    }

    function verlaufSchliessen() {
      var box = document.querySelector('[data-dl-history]');
      if (box && box.parentNode) box.parentNode.removeChild(box);
      verlaufOffen = false;
    }

    function renderVerlauf(j) {
      var alt = document.querySelector('[data-dl-history]');
      if (alt && alt.parentNode) alt.parentNode.removeChild(alt);

      var box = document.createElement('div');
      box.setAttribute('data-dl-history', '');
      box.setAttribute('role', 'dialog');
      box.style.cssText = 'position:fixed;left:50%;bottom:74px;transform:translateX(-50%);z-index:460;background:var(--bg-card);border:1px solid var(--gold);color:var(--ink);padding:14px 18px;border-radius:14px;font-size:13px;max-width:min(92vw,480px);max-height:min(70vh,560px);overflow:auto;box-shadow:0 16px 40px oklch(0 0 0 / .5)';

      var kopf = document.createElement('div');
      kopf.style.cssText = 'display:flex;gap:12px;align-items:baseline;justify-content:space-between;margin-bottom:10px';
      var titel = document.createElement('strong');
      titel.textContent = T('search.dl_history', 'Your recent downloads');
      kopf.appendChild(titel);
      var zu = document.createElement('button');
      zu.type = 'button';
      zu.setAttribute('aria-label', T('search.dl_close', 'Close'));
      zu.textContent = '✕';
      zu.style.cssText = 'border:0;background:transparent;color:var(--ink);opacity:.7;cursor:pointer;font:inherit;font-size:15px;line-height:1;padding:2px 4px';
      zu.addEventListener('click', verlaufSchliessen);
      kopf.appendChild(zu);
      box.appendChild(kopf);

      var eintraege = (j && j.entries) || [];
      if (j && j.busy) {
        var warn = document.createElement('div');
        warn.setAttribute('role', 'alert');
        warn.style.cssText = 'margin:0 0 10px;padding:9px 12px;border-radius:8px;line-height:1.45;border:1px solid rgba(224,92,84,.85);background:rgba(224,92,84,.16);color:#ffb3ad';
        warn.textContent = '⚠  ' + busyText(j.busy);
        box.appendChild(warn);
      }

      // Der laufende Download hat noch KEINE Verlaufszeile: die entsteht erst nach dem
      // letzten Byte. Deshalb bekommt er eine eigene Zeile ganz oben, mit Balken.
      var aktiv = aktivLesen();
      if (aktiv) {
        var lauf = document.createElement('div');
        lauf.style.cssText = 'margin:6px 0 10px;padding:9px 12px;border-radius:8px;border:1px solid var(--gold);line-height:1.45';
        var lname = document.createElement('div');
        lname.style.cssText = 'overflow:hidden;text-overflow:ellipsis;white-space:nowrap';
        lname.textContent = '↧  ' + (aktiv.name || T('search.dl_running_short', 'Downloading'));
        lauf.appendChild(lname);

        var rahmen = document.createElement('div');
        rahmen.style.cssText = 'margin:7px 0 5px;height:6px;border-radius:3px;background:rgba(255,255,255,.10);overflow:hidden';
        var balken = document.createElement('div');
        balken.setAttribute('data-dl-live-bar', '');
        balken.style.cssText = 'height:100%;width:0%;background:var(--gold);transition:width .4s linear';
        rahmen.appendChild(balken);
        lauf.appendChild(rahmen);

        var lstat = document.createElement('div');
        lstat.setAttribute('data-dl-live-text', '');
        lstat.style.cssText = 'opacity:.65;font-size:12px';
        lstat.textContent = T('search.dl_preparing_short', 'Preparing…');
        lauf.appendChild(lstat);

        box.appendChild(lauf);
        if (letzterStand) {
          // Direkt mit dem letzten bekannten Stand fuellen, sonst blinkt die Zeile bis
          // zum naechsten Takt auf null.
          window.setTimeout(function () { zeileAktualisieren(letzterStand); }, 0);
        }
      }

      if (!eintraege.length) {
        var leer = document.createElement('div');
        leer.style.cssText = 'opacity:.7;line-height:1.5';
        leer.textContent = T('search.dl_history_empty', 'No downloads recorded yet.');
        box.appendChild(leer);
      }

      eintraege.forEach(function (e) {
        var zeile = document.createElement('div');
        zeile.style.cssText = 'display:flex;gap:10px;align-items:center;margin:6px 0;padding:8px 12px;border-radius:8px;border:1px solid var(--rule);line-height:1.45';

        var text = document.createElement('div');
        text.style.cssText = 'flex:1;min-width:0';
        var name = document.createElement('div');
        name.style.cssText = 'overflow:hidden;text-overflow:ellipsis;white-space:nowrap';
        name.textContent = (e.completed ? '✓  ' : '⚠  ') + e.name;
        text.appendChild(name);
        var unten = document.createElement('div');
        unten.style.cssText = 'opacity:.65;font-size:12px';
        unten.textContent = fmtZeit(e.at) + '  ·  ' + fmtBytes(e.bytes) + '  ·  '
          + (e.completed
              ? T('search.dl_state_done', 'completed')
              : T('search.dl_state_aborted', 'stopped before the end'))
          + (e.resumed ? ('  ·  ' + T('search.dl_state_resumed', 'resumed')) : '');
        text.appendChild(unten);
        zeile.appendChild(text);

        if (e.url) {
          var neu = document.createElement('button');
          neu.type = 'button';
          neu.textContent = T('search.dl_restart', 'Start again');
          neu.style.cssText = 'flex:0 0 auto;padding:6px 12px;border:1px solid var(--gold);border-radius:8px;background:transparent;color:var(--ink);cursor:pointer;font:inherit;font-size:12px';
          neu.addEventListener('click', function () {
            if (neu.disabled) return;
            neu.disabled = true;
            // Der Eintrag traegt einen fertigen Token und wuerde direkt zur Cloud
            // navigieren. Laeuft dort schon ein Download, kaeme statt der Datei eine
            // Hinweisseite und die Storefront waere weg. Deshalb vorher fragen.
            verlaufHolen(function (frisch) {
              neu.disabled = false;
              if (frisch && frisch.busy) { renderVerlauf(frisch); return; }
              window.location.href = e.url;
              // Der Verlauf traegt die sel im Eintrag, damit greift derselbe Takt wie
              // beim ersten Start. Ein Verlaufseintrag steht immer fuer genau einen
              // Teil, also ist die Warteschlange hier einelementig; die Teilmarke am
              // Symbol bleibt dann leer.
              downloadBegonnen({ parts: [{ sel: e.sel, url: e.url, bytes: e.bytes }], name: e.name });
            });
          });
          zeile.appendChild(neu);
        }
        box.appendChild(zeile);
      });

      // Steht ein geteilter Lauf in der Liste, bleibt die Erklaerung dazu hier stehen.
      // Der Hinweis beim Start ist nach zwei Sekunden weg; wer sich am naechsten Tag
      // fragt, warum da zwei Dateien liegen und ob eine kaputt ist, findet die Antwort
      // sonst nirgends. Erkennbar am Namen, den der Server vergibt: er traegt bei
      // geteilten Buendeln die Teilnummer.
      var hatTeile = (eintraege || []).some(function (e) {
        return /Part-\d+-of-\d+/.test(String(e && e.name || ''));
      });
      if (hatTeile) {
        var teilFuss = document.createElement('div');
        teilFuss.style.cssText = 'margin-top:10px;opacity:.75;font-size:12px;line-height:1.45';
        teilFuss.textContent = T('search.dl_all_parts_done',
          'All parts downloaded. Each file is an ordinary ZIP and is used just like a single one; together they hold the whole selection.');
        box.appendChild(teilFuss);
      }

      if (j && j.note === 'battlemaps_not_tracked') {
        var fuss = document.createElement('div');
        fuss.style.cssText = 'margin-top:10px;opacity:.6;font-size:12px;line-height:1.45';
        fuss.textContent = T('search.dl_history_note', 'Battlemap downloads are served straight from the CDN and are not listed here.');
        box.appendChild(fuss);
      }

      document.body.appendChild(box);
      verlaufOffen = true;
    }

    function verlaufAnzeigen() {
      verlaufHolen(function (j) { renderVerlauf(j); });
    }

    // ---------- laufender Download: Symbol und Balken ----------
    // Die Seite kann den Download des Browsers nicht beobachten, er laeuft als
    // Navigation. Der Balken kommt deshalb vom Server: streamBundle schreibt seinen
    // Stand mit, resource=bulk_progress liest ihn.
    var letzterStand = null;

    function fortschrittHolen(sel, fertig) {
      fetch(withParam(proxyUrl, 'resource=bulk_progress&sel=' + encodeURIComponent(sel)),
        { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (j) { fertig(j && j.result === 'OK' ? j : null); })
        .catch(function () { fertig(null); });
    }

    function chipEntfernen() {
      var c = document.querySelector('[data-dl-chip]');
      if (c && c.parentNode) c.parentNode.removeChild(c);
    }

    // Eingeklapptes Symbol unten rechts. Zeigt den Prozentsatz, solange geladen wird,
    // und oeffnet auf Klick den Verlauf.
    function chipZeichnen(text) {
      var chip = document.querySelector('[data-dl-chip]');
      if (!chip) {
        chip = document.createElement('div');
        chip.setAttribute('data-dl-chip', '');
        chip.style.cssText = 'position:fixed;right:18px;bottom:74px;z-index:459;display:flex;gap:8px;align-items:center;background:var(--bg-card);border:1px solid var(--gold);color:var(--ink);padding:8px 10px 8px 14px;border-radius:30px;font:inherit;font-size:12px;box-shadow:0 10px 30px oklch(0 0 0 / .45)';
        var auf = document.createElement('button');
        auf.type = 'button';
        auf.setAttribute('data-dl-chip-open', '');
        auf.style.cssText = 'border:0;background:transparent;color:inherit;font:inherit;cursor:pointer;padding:0';
        auf.addEventListener('click', function () { verlaufAnzeigen(); });
        chip.appendChild(auf);
        var zu = document.createElement('button');
        zu.type = 'button';
        zu.setAttribute('aria-label', T('search.dl_close', 'Close'));
        zu.textContent = '✕';
        zu.style.cssText = 'border:0;background:transparent;color:inherit;opacity:.6;font:inherit;font-size:13px;line-height:1;cursor:pointer;padding:0 2px';
        zu.addEventListener('click', function () { chipEntfernen(); });
        chip.appendChild(zu);
        document.body.appendChild(chip);
      }
      chip.querySelector('[data-dl-chip-open]').textContent = text;
    }

    // Ein Download wurde gestartet: merken, Symbol zeigen, Takt anwerfen.
    function downloadBegonnen(j) {
      var teile = (j && j.parts && j.parts.length) ? j.parts : [];
      if (!teile.length || !teile[0].sel) return;
      aktivSetzen(teile, 0, j.name || '');
      chipZeichnen(teilMarke(aktivLesen()) + T('search.dl_preparing_short', 'Preparing…'));
      fortschrittTakt();
    }

    // Pause zwischen zwei Teilen.
    //
    // Der Ursprung gibt seine Sperre nach einem sauberen Ende nicht sofort frei,
    // sondern laesst BUNDLE_LOCK_GRACE stehen, damit ein Doppelklick nicht gleich das
    // naechste Buendel anwirft. Wer den naechsten Teil sofort anfordert, bekommt
    // deshalb die Hinweisseite mit 429 statt eines Archivs, und weil der Teil per
    // Navigation geholt wird, waere die Bibliothek danach weg. Fuenf Sekunden ueber
    // der Nachlauffrist ist die einfachste Antwort darauf, die nicht raet.
    var TEIL_PAUSE_MS = 35000;

    function fortschrittTakt() {
      if (fortschrittTimer) { window.clearInterval(fortschrittTimer); fortschrittTimer = null; }
      var aktiv = aktivLesen();
      if (!aktiv) { chipEntfernen(); return; }
      var stillSeit = Date.now();
      var vorherGesendet = -1;

      function tick() {
        var a = aktivLesen();
        if (!a) {                        // abgelaufen
          window.clearInterval(fortschrittTimer); fortschrittTimer = null;
          letzterStand = null; chipEntfernen();
          if (verlaufOffen) verlaufAnzeigen();
          return;
        }
        fortschrittHolen(a.sel, function (p) {
          if (!p) return;
          letzterStand = p;
          if (p.sent !== vorherGesendet) { vorherGesendet = p.sent; stillSeit = Date.now(); }

          if (p.total > 0 && p.sent >= p.total) {
            window.clearInterval(fortschrittTimer); fortschrittTimer = null;
            letzterStand = null;

            // Steht noch ein Teil aus, geht es weiter statt zu Ende.
            //
            // Der Stand kommt vom Ursprung, nicht vom Browser: fertig heisst hier, dass
            // der Server das Archiv erzeugt und abgegeben hat. Der Kunde laedt womoeglich
            // noch minutenlang daran, weil die Weiterleitung fuer ihn zwischenspeichert.
            // Das ist gewollt: der naechste Teil wird waehrenddessen schon erzeugt und
            // wartet auf ihn, statt die Leitung nacheinander zweimal leer stehen zu lassen.
            var naechster = a.teile && a.teile[(a.index || 0) + 1];
            if (naechster && naechster.url) {
              var kommend = { teile: a.teile, index: (a.index || 0) + 1 };
              chipZeichnen(teilMarke(kommend) + T('search.dl_preparing_short', 'Preparing…'));
              window.setTimeout(function () {
                aktivSetzen(a.teile, (a.index || 0) + 1, a.name);
                window.location.href = naechster.url;
                fortschrittTakt();
              }, TEIL_PAUSE_MS);
              return;
            }

            // Durch. Der Verlaufseintrag entsteht gleich, also einmal auffrischen.
            //
            // War es ein geteilter Lauf, sagen wir hier zum einzigen Mal ausdruecklich,
            // was der Kunde jetzt vor sich hat: mehrere gewoehnliche ZIP-Dateien, die
            // zusammen die Auswahl ergeben. Vorher stand das nirgends, und die Frage
            // "was mache ich mit zwei Archiven" hatte im ganzen Laden keine Antwort.
            if (a.teile && a.teile.length > 1) {
              toast(T('search.dl_all_parts_done',
                'All parts downloaded. Each file is an ordinary ZIP and is used just like a single one; together they hold the whole selection.'));
            }
            aktivLoeschen(); chipEntfernen();
            if (verlaufOffen) window.setTimeout(verlaufAnzeigen, 1500);
            return;
          }

          var prozent = p.total > 0 ? Math.min(99, Math.floor(p.sent * 100 / p.total)) : 0;
          chipZeichnen(teilMarke(a) + (p.known && p.total > 0
            ? (T('search.dl_running_short', 'Downloading') + ' ' + prozent + '%')
            : T('search.dl_preparing_short', 'Preparing…')));
          if (verlaufOffen) zeileAktualisieren(p);

          // Steht der Stand eine Minute still, ist der Download mit hoher
          // Wahrscheinlichkeit abgebrochen. Dann einmal den Verlauf zeigen, damit der
          // Neustart erreichbar ist, statt still weiterzuzaehlen.
          if (Date.now() - stillSeit > 60000) {
            window.clearInterval(fortschrittTimer); fortschrittTimer = null;
            aktivLoeschen(); letzterStand = null; chipEntfernen();
            verlaufAnzeigen();
          }
        });
      }
      fortschrittTimer = window.setInterval(tick, 3000);
      tick();
    }

    // Balken der laufenden Zeile nachziehen, ohne das ganze Fenster neu zu bauen.
    function zeileAktualisieren(p) {
      var bar = document.querySelector('[data-dl-live-bar]');
      var txt = document.querySelector('[data-dl-live-text]');
      if (!bar || !txt) return;
      var prozent = p.total > 0 ? Math.min(100, p.sent * 100 / p.total) : 0;
      bar.style.width = prozent.toFixed(1) + '%';
      txt.textContent = fmtBytes(p.sent) + (p.total > 0 ? ' / ' + fmtBytes(p.total) : '')
        + '  ·  ' + Math.floor(prozent) + '%';
    }

    // Beim Zurueckkommen in den Tab den offenen Verlauf auffrischen.
    window.addEventListener('focus', function () {
      if (verlaufOffen) verlaufHolen(function (j) { if (verlaufOffen) renderVerlauf(j); });
      if (!fortschrittTimer && aktivLesen()) fortschrittTakt();
    });

    function renderSidebar() {
      var side = root.querySelector('[data-side]');
      var fdef = FACETS[state.kind];
      var f = state.filters[state.kind];
      var items = state.data[state.kind] || [];
      var accessN, lockedN;
      if (state.kind === 'battlemap') {
        // The battlemap tab renders releases/scenes/bundles, not the generic
        // catalog entries, so the access counts must follow the active view
        // (the catalog-based count was quasi-static and wrong here).
        var pool, hasAcc;
        if (state.bmapView === 'bundles') { pool = state.bundles || []; hasAcc = bundleHasAccess; }
        else if (state.bmapView === 'individual') { pool = individualMapItems(); hasAcc = function (s) { return releaseHasAccess(s._release); }; }
        else { pool = state.releases || []; hasAcc = releaseHasAccess; }
        accessN = pool.filter(hasAcc).length;
        lockedN = pool.length - accessN;
      } else {
        accessN = items.filter(function (i) { return i.perm !== 'locked'; }).length;
        lockedN = items.length - accessN;
      }
      var html = '<div class="brw-filter-h"><span class="t">Refine</span><button class="reset" data-reset>Reset</button></div>';
      // Creatures: prominent Beneos Originals / SRD source toggles (default both on).
      if (state.kind === 'token') {
        var src = f._src || ['srd', 'original'];
        var srdN = items.filter(function (i) { return i.srd; }).length;
        var origN = items.length - srdN;
        html += '<div class="fsrc-grp">' +
          srcToggle('original', T('search.src_originals', 'Beneos Originals'), '', src.indexOf('original') !== -1, origN) +
          srcToggle('srd', 'SRD', T('search.src_srd', 'System Reference Document, the official Dungeons & Dragons SRD creatures'), src.indexOf('srd') !== -1, srdN) +
          '</div>';
      }
      // access
      html += '<div class="fchip-grp"><div class="fchip-grp-h"><span class="t">Access</span></div><div class="fchip-grp-b">' +
        accessChip('owned', T('search.access_owned', 'You have access'), accessN, f) +
        accessChip('locked', T('search.access_locked', 'Locked'), lockedN, f) +
        '</div></div>';
      // range
      if (fdef.range) {
        var r = f._range || [0, fdef.range.max];
        html += '<div class="fchip-grp"><div class="fchip-grp-h"><span class="t">' + esc(fdef.range.label) + '</span><span class="s">' + (r[0] === 0 && r[1] === fdef.range.max ? T('search.range_any', 'Any') : (r[0] + ' – ' + (r[1] === fdef.range.max ? r[1] + '+' : r[1]))) + '</span></div>' +
          rangeSlider(r, fdef.range.max) + '</div>';
      }
      // facet selects
      fdef.selects.forEach(function (sel) {
        var selected = f[sel.key] || [];
        html += '<div class="fchip-grp"><div class="fchip-grp-h"><span class="t">' + esc(sel.label) + '</span>' + (selected.length ? '<span class="s">' + selected.length + ' active</span>' : '') + '</div>' +
          facetSelect(sel, selected) + '</div>';
      });
      side.innerHTML = html;
      wireRange();
    }

    function srcToggle(val, label, tip, on, count) {
      return '<button class="fsrc' + (on ? ' on' : '') + '" data-src="' + val + '"' +
        (tip ? ' title="' + esc(tip) + '"' : '') + ' aria-pressed="' + (on ? 'true' : 'false') + '">' +
        '<span class="fsrc-box">' + (on ? SVG.check : '') + '</span>' +
        '<span class="fsrc-lab">' + esc(label) + '</span>' +
        '<span class="fsrc-cnt">' + count + '</span></button>';
    }

    function accessChip(val, label, count, f) {
      var on = (f._perm || []).indexOf(val) !== -1;
      return '<button class="fchip perm-' + val + (on ? ' on' : '') + '" data-perm="' + val + '"><span>' + esc(label) + '</span><span class="fchip-cnt">' + count + '</span></button>';
    }

    function facetSelect(sel, selected) {
      var open = state.openMenu === sel.key;
      var opts = optionsFor(sel).filter(function (o) { return selected.indexOf(o.value) === -1; });
      var html = '<div class="facet-sel" data-facet="' + esc(sel.key) + '">' +
        '<button class="facet-sel-trigger' + (open ? ' open' : '') + '" data-facet-toggle>' +
          '<span class="facet-sel-ph">Add ' + esc(sel.label.toLowerCase()) + '…</span>' +
          '<span class="facet-sel-chev' + (open ? ' flip' : '') + '">' + SVG.chev + '</span></button>';
      if (open) {
        html += '<div class="facet-sel-menu">' + (opts.length ? opts.map(function (o) {
          return '<button class="facet-sel-opt" data-facet-add="' + esc(o.value) + '"><span>' + esc(o.label) + '</span><span class="facet-sel-cnt">' + o.count + '</span></button>';
        }).join('') : '<div class="facet-sel-empty">All values selected</div>') + '</div>';
      }
      if (selected.length) {
        html += '<div class="facet-sel-active">' + selected.map(function (v) {
          return '<button class="afchip" data-facet-rm="' + esc(v) + '">' + esc(dispVal(sel.path, v)) + '<span class="x">' + SVG.x + '</span></button>';
        }).join('') + '</div>';
      }
      return html + '</div>';
    }

    function rangeSlider(r, max) {
      var pctLo = (r[0] / max) * 100, pctHi = (r[1] / max) * 100;
      var ticks = [0, 0.25, 0.5, 0.75, 1].map(function (t) { return '<div class="crslider-tick" style="left:' + (t * 100) + '%"></div>'; }).join('');
      return '<div class="crslider" data-range max="' + max + '"><div class="crslider-track" data-track>' +
        '<div class="crslider-rail"></div><div class="crslider-fill" style="left:' + pctLo + '%;right:' + (100 - pctHi) + '%"></div>' + ticks +
        '<div class="crslider-thumb" data-thumb="lo" style="left:' + pctLo + '%"><span class="crslider-bubble">' + r[0] + '</span></div>' +
        '<div class="crslider-thumb" data-thumb="hi" style="left:' + pctHi + '%"><span class="crslider-bubble">' + (r[1] === max ? r[1] + '+' : r[1]) + '</span></div>' +
        '</div><div class="crslider-labels"><span>0</span><span>' + max + '+</span></div></div>';
    }

    function wireRange() {
      var el = root.querySelector('[data-range]'); if (!el) return;
      var max = parseFloat(el.getAttribute('max'));
      var track = el.querySelector('[data-track]');
      var f = state.filters[state.kind];
      if (!f._range) f._range = [0, max];
      Array.prototype.forEach.call(el.querySelectorAll('[data-thumb]'), function (th) {
        th.addEventListener('mousedown', start); th.addEventListener('touchstart', start, { passive: false });
        function start(ev) {
          ev.preventDefault();
          var which = th.getAttribute('data-thumb');
          function move(e) {
            var rect = track.getBoundingClientRect();
            var cx = e.touches ? e.touches[0].clientX : e.clientX;
            var pct = Math.max(0, Math.min(1, (cx - rect.left) / rect.width));
            var v = Math.round(pct * max);
            if (which === 'lo') f._range = [Math.min(v, f._range[1]), f._range[1]];
            else f._range = [f._range[0], Math.max(v, f._range[0])];
            var lo = f._range[0], hi = f._range[1];
            var fill = el.querySelector('.crslider-fill');
            if (fill) { fill.style.left = (lo / max * 100) + '%'; fill.style.right = (100 - hi / max * 100) + '%'; }
            var loT = el.querySelector('[data-thumb="lo"]'), hiT = el.querySelector('[data-thumb="hi"]');
            if (loT) { loT.style.left = (lo / max * 100) + '%'; var b1 = loT.querySelector('.crslider-bubble'); if (b1) { b1.textContent = lo; b1.style.opacity = '1'; } }
            if (hiT) { hiT.style.left = (hi / max * 100) + '%'; var b2 = hiT.querySelector('.crslider-bubble'); if (b2) { b2.textContent = (hi === max ? hi + '+' : hi); b2.style.opacity = '1'; } }
            var grp = el.closest('.fchip-grp'); var sEl = grp && grp.querySelector('.fchip-grp-h .s');
            if (sEl) sEl.textContent = (lo === 0 && hi === max) ? T('search.range_any', 'Any') : (lo + ' – ' + (hi === max ? hi + '+' : hi));
            state.visible = PAGE; renderResults(); renderActive();
          }
          function up() { document.removeEventListener('mousemove', move); document.removeEventListener('mouseup', up); document.removeEventListener('touchmove', move); document.removeEventListener('touchend', up); }
          document.addEventListener('mousemove', move); document.addEventListener('mouseup', up);
          document.addEventListener('touchmove', move, { passive: false }); document.addEventListener('touchend', up);
        }
      });
    }

    function renderActive() {
      var box = root.querySelector('[data-active]');
      var f = state.filters[state.kind]; var fdef = FACETS[state.kind];
      var chips = [];
      (f._perm || []).forEach(function (v) { chips.push({ t: 'perm', v: v, label: v === 'owned' ? T('search.access_owned', 'You have access') : T('search.access_locked', 'Locked') }); });
      if (fdef.range && f._range && !(f._range[0] === 0 && f._range[1] === fdef.range.max)) {
        chips.push({ t: 'range', label: fdef.range.label + ' ' + f._range[0] + '–' + (f._range[1] === fdef.range.max ? f._range[1] + '+' : f._range[1]) });
      }
      fdef.selects.forEach(function (sel) { (f[sel.key] || []).forEach(function (v) { chips.push({ t: 'sel', key: sel.key, v: v, label: dispVal(sel.path, v) }); }); });
      if (!chips.length) { box.innerHTML = ''; return; }
      box.innerHTML = '<span class="lab">Active</span>' + chips.map(function (c) {
        return '<button class="afchip" data-rmchip="' + c.t + '" data-rmkey="' + esc(c.key || '') + '" data-rmval="' + esc(c.v || '') + '">' + esc(c.label) + '<span class="x">' + SVG.x + '</span></button>';
      }).join('') + '<button class="afchip clear" data-reset>Clear all</button>';
    }

    // Plan §19.5 — battlemap-item to parent-release lookup. Catalog entries
    // carry `cloud_release_id` and `release_dir`; we keyed state.releases by
    // both during load so either resolves.
    function releaseFor(it) {
      if (!it || it.kind !== 'battlemap') return null;
      var p = it.props || {};
      if (p.cloud_release_id && state.releaseById && state.releaseById[p.cloud_release_id]) return state.releaseById[p.cloud_release_id];
      if (p.release_dir && state.releaseByDir && state.releaseByDir[p.release_dir]) return state.releaseByDir[p.release_dir];
      return null;
    }
    function humanBytes(n) {
      if (n == null || isNaN(n)) return '';
      var b = Number(n);
      if (b < 1024) return b + ' B';
      var u = ['KB', 'MB', 'GB', 'TB'], i = -1;
      do { b /= 1024; i++; } while (b >= 1024 && i < u.length - 1);
      return (b >= 10 ? Math.round(b) : Math.round(b * 10) / 10) + ' ' + u[i];
    }
    // Plan §46.3 — render the content-volume line under a release card.
    // Uses the stats object emitted by bm_compute_release_stats() so the
    // count is authoritative (file-system derived, never the smaller
    // catalog-only count). Renders as "M maps · S sceneries · H handouts".
    function releaseStatsLine(r) {
      var s = (r && r.stats) ? r.stats : null;
      if (!s) return r && r.scene_count ? (r.scene_count + ' scene' + (r.scene_count === 1 ? '' : 's')) : '';
      var p = function (n, sing, plur) { return n + ' ' + (n === 1 ? sing : (plur || sing + 's')); };
      var parts = [];
      if (s.battlemaps)     parts.push(p(s.battlemaps,     'map'));
      if (s.sceneries)      parts.push(p(s.sceneries,      'scenery', 'sceneries'));
      if (s.intros)         parts.push(p(s.intros,         'intro'));
      if (s.overview)       parts.push(p(s.overview,       'overview'));
      if (s.standalones)    parts.push(p(s.standalones,    'standalone'));
      if (s.handouts)       parts.push(p(s.handouts,       'handout'));
      if (s.ambient_tracks) parts.push(s.ambient_tracks + ' ambient');
      return parts.join(' · ');
    }
    function releaseHasTrailer(r) {
      return !!(r && (r.trailer_url || r.videourl));
    }
    function releaseHasGallery(r) {
      var s = r && r.stats; if (!s) return false;
      return (s.handouts || 0) > 0 || (s.battlemaps || 0) > 0;
    }
    // Plan §48.C — adventure tags for "Compatible with X" chips.
    // Backend aggregates release-level (catalog scene-slug lookup misses on
    // §43 .scenes/, but release_dir matching does not — see app-proxy.php
    // $catReleaseAdvs). Falls back to per-scene aggregation if the backend
    // didn't include the release-level array.
    function releaseAdventures(r) {
      if (r && Array.isArray(r.adventures) && r.adventures.length) return r.adventures;
      var set = {};
      (r && r.scenes || []).forEach(function (s) {
        if (Array.isArray(s.adventure)) s.adventure.forEach(function (a) {
          var v = (a || '').trim();
          if (v) set[v] = 1;
        });
      });
      return Object.keys(set).sort();
    }
    // Plan §49.F — release-date for "newest on top" sort. Backend aggregates
    // max(release_date, updated_date) from catalog properties; we just read.
    function releaseDateKey(r) {
      return (r && r.release_date) ? String(r.release_date) : '';
    }
    // Plan §50.F — release_num normalized for sort. Plan §30 reserves 9000+
    // as the Outlier/Combo virtual-number range (e.g. bm_9000 "Sci Fi Pack").
    // These should sort BELOW the mainline (1..499) regardless of their
    // numeric height. We map them to negative numbers so mainline 110 > 50 >
    // 1 > -9000 > -9100 etc.
    function releaseNumKey(r) {
      if (!r) return 0;
      var n = parseInt(r.release_num, 10);
      if (isNaN(n)) return -1; // unnumbered → after mainline, before outliers
      if (n >= 9000) return -n; // outliers go to the tail
      return n;
    }
    // Free-pack-first ranking. Every release ships the free static-map ZIP, so
    // nothing is ever "locked"; the real distinction is whether the COMPLETE
    // pack is free (the 4 admin-flagged free releases) vs premium (animated pack
    // behind Patreon/shop, static maps still free). Free packs sort on top.
    function releaseLockedRank(r) { return (r && r.is_free) ? 0 : 1; }
    // Largest parsable grid area across a release's aggregated grid facets.
    function releaseMaxGridArea(r) {
      var best = null;
      releaseFacetVals(r, 'grid').forEach(function (g) {
        var a = gridArea(g);
        if (a != null && (best == null || a > best)) best = a;
      });
      return best;
    }
    // True when the user can actually get at the full release: free pack,
    // installable, or any non-free unlocked download (mirrors the paid-signal
    // walk in computeIsFreeAccount).
    function releaseHasAccess(r) {
      if (!r) return false;
      if (r.is_free || r.can_install === true) return true;
      var dls = r.available_downloads || [];
      for (var i = 0; i < dls.length; i++) {
        var d = dls[i];
        if (d && d.state !== 'locked' && d.source && d.source !== 'free') return true;
      }
      return false;
    }
    // Group band for the battlemap views: 'owned' regroups by access, every
    // other sort mode keeps the free-pack vs premium segmentation.
    function releaseGroupRank(r) {
      return state.sort === 'owned' ? (releaseHasAccess(r) ? 0 : 1) : releaseLockedRank(r);
    }
    // True when any member release of the bundle is accessible.
    function bundleHasAccess(b) {
      return ((b && b.members) || []).some(function (m) {
        var r = state.releaseById && state.releaseById[m.asset_id];
        return !!(r && releaseHasAccess(r));
      });
    }
    // Access-chip filter (owned/locked) for the battlemap views. Selecting
    // both or neither means "no filter", mirroring the generic items path.
    function permPass(f, accessible) {
      var p = f && f._perm;
      if (!p || !p.length || p.length >= 2) return true;
      return p[0] === 'owned' ? !!accessible : !accessible;
    }
    // release_num is the canonical recency signal, release_date breaks ties.
    function releaseRecencyCmp(a, b) {
      var na = releaseNumKey(a), nb = releaseNumKey(b);
      if (na !== nb) return nb - na;
      var da = releaseDateKey(a), db = releaseDateKey(b);
      if (da === db) return 0;
      if (!da) return 1;
      if (!db) return -1;
      return da < db ? 1 : -1;
    }
    function releaseNameKey(r) { return String((r && (r.display_name || r.release_dir)) || ''); }
    // Within-band order per toolbar sort mode. 'cr' means map size here:
    // grid area, falling back to scene count, then pack bytes.
    function releaseInnerCmp(a, b) {
      var an = releaseNameKey(a), bn = releaseNameKey(b);
      if (state.sort === 'name' || state.sort === 'owned') return an.localeCompare(bn);
      if (state.sort === 'cr') {
        return cmpNullsLast(releaseMaxGridArea(a), releaseMaxGridArea(b)) ||
               cmpNullsLast(a.scene_count, b.scene_count) ||
               cmpNullsLast(a.bytes_total, b.bytes_total) ||
               an.localeCompare(bn);
      }
      return releaseRecencyCmp(a, b) || an.localeCompare(bn);
    }
    // Sort releases: group band first, then the selected sort within each band.
    function sortReleases(list) {
      return list.slice().sort(function (a, b) {
        return releaseGroupRank(a) - releaseGroupRank(b) || releaseInnerCmp(a, b);
      });
    }
    // Plan §50.B — adventure name → compact acronym chip. Capitalize first
    // and last word, lowercase any middle "filler" words (of, in, the, into, ...).
    // "Curse of Strahd" → "CoS", "Descent into Avernus" → "DiA",
    // "Out of the Abyss" → "OotA". Single-word names return uppercased first 3 chars.
    function adventureAcronym(name) {
      var n = String(name || '').trim();
      if (!n) return '';
      var words = n.split(/\s+/);
      if (words.length === 1) return words[0].slice(0, 3).toUpperCase();
      return words.map(function (w, i) {
        var c = w.charAt(0);
        return (i === 0 || i === words.length - 1) ? c.toUpperCase() : c.toLowerCase();
      }).join('');
    }
    // Plan §50.E — IntersectionObserver-based lazy-load for handout tiles.
    // Browsers' native loading="lazy" still triggers all fetches up-front when
    // images are technically below the fold but inside a scrollable container;
    // an explicit observer fixes the lag on releases with 50+ handouts.
    var __lazyObserver = null;
    function getLazyObserver() {
      if (__lazyObserver || typeof IntersectionObserver === 'undefined') return __lazyObserver;
      __lazyObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          var el = e.target;
          var src = el.getAttribute('data-src');
          if (src) {
            el.src = src;
            el.removeAttribute('data-src');
            el.addEventListener('load', function () { el.parentNode && el.parentNode.classList.remove('is-loading'); }, { once: true });
            el.addEventListener('error', function () { el.parentNode && el.parentNode.classList.remove('is-loading'); }, { once: true });
          }
          __lazyObserver.unobserve(el);
        });
      }, { rootMargin: '200px 0px' });
      return __lazyObserver;
    }
    function attachLazyImages(root) {
      var ob = getLazyObserver();
      if (!ob) {
        // No IntersectionObserver (old browser) — just set src directly.
        Array.prototype.forEach.call(root.querySelectorAll('img[data-src]'), function (el) {
          el.src = el.getAttribute('data-src');
          el.removeAttribute('data-src');
        });
        return;
      }
      Array.prototype.forEach.call(root.querySelectorAll('img[data-src]'), function (el) { ob.observe(el); });
    }
    // Plan §53.A — hover-zoom preview for scene thumbnails. Shows the image at
    // its native 400px-wide resolution next to the cursor on mouseenter, removed
    // on mouseleave. Positioned to avoid clipping the right viewport edge.
    function attachHoverZoom(root) {
      var els = root.querySelectorAll('.bm-scene-thumb, .bm-gallery-tile');
      Array.prototype.forEach.call(els, function (el) {
        if (el.__bmZoomBound) return;
        el.__bmZoomBound = true;
        var preview = null;
        var timer = null;
        el.addEventListener('mouseenter', function () {
          var img = el.querySelector('img');
          var src = img && (img.currentSrc || img.src);
          if (!src) return;
          // small delay so quick mouse-sweeps don't flicker previews
          timer = setTimeout(function () {
            preview = document.createElement('div');
            preview.className = 'bm-hover-zoom-preview';
            preview.innerHTML = '<img src="' + esc(src) + '" alt="">';
            document.body.appendChild(preview);
            var rect = el.getBoundingClientRect();
            var W = 420, pad = 8;
            var left = rect.right + pad;
            if (left + W > window.innerWidth - 8) left = rect.left - W - pad;
            if (left < 8) left = 8;
            var top = rect.top + window.scrollY;
            // keep preview within viewport-y when scrolled
            if (top + 250 > window.scrollY + window.innerHeight) {
              top = window.scrollY + window.innerHeight - 260;
            }
            preview.style.left = left + 'px';
            preview.style.top = top + 'px';
          }, 120);
        });
        el.addEventListener('mouseleave', function () {
          if (timer) { clearTimeout(timer); timer = null; }
          if (preview) { preview.remove(); preview = null; }
        });
      });
    }
    // Plan §46.5 — fetch media (cover + scene-thumbs + handouts) for a release.
    // Result is cached per release_dir for the lifetime of the page; gallery
    // open/close does not re-fetch.
    var mediaCache = {};
    function fetchReleaseMedia(releaseDir, variant) {
      var key = releaseDir + '|' + (variant || '');
      if (mediaCache[key]) return Promise.resolve(mediaCache[key]);
      // App-proxy resource=release_media (Plan §46.5) — same auth as library.
      var url = proxyUrl + (proxyUrl.indexOf('?') >= 0 ? '&' : '?') +
                'resource=release_media&release_dir=' + encodeURIComponent(releaseDir) +
                (variant ? '&variant=' + encodeURIComponent(variant) : '');
      return fetch(url, { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (j) {
          if (j && j.result === 'OK' && j.data && Array.isArray(j.data.media)) {
            mediaCache[key] = j.data.media;
            return j.data.media;
          }
          return [];
        }).catch(function () { return []; });
    }
    // Plan §46.6 — return an inline <iframe> embed for YouTube/Vimeo URLs, or
    // null if the URL is from any other host (caller then opens it in a new tab).
    // No remote validation; URL must match the standard share-link patterns.
    function trailerEmbedHtml(url) {
      if (!url) return null;
      var yt = String(url).match(/(?:youtu\.be\/|youtube\.com\/(?:watch\?v=|embed\/|shorts\/))([\w-]{11})/);
      if (yt) return '<iframe src="https://www.youtube.com/embed/' + yt[1] + '" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen frameborder="0" style="width:100%;aspect-ratio:16/9;display:block"></iframe>';
      var vm = String(url).match(/vimeo\.com\/(?:video\/)?(\d+)/);
      if (vm) return '<iframe src="https://player.vimeo.com/video/' + vm[1] + '" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen frameborder="0" style="width:100%;aspect-ratio:16/9;display:block"></iframe>';
      return null;
    }
    // Plan §46.5 — Lightbox: full-screen overlay with arrow/tab navigation.
    // No framework, vanilla DOM. Closes on Esc or click outside.
    function openLightbox(items, startIdx) {
      if (!items || !items.length) return;
      var idx = Math.max(0, Math.min(startIdx | 0, items.length - 1));
      var ov = document.createElement('div');
      ov.className = 'bm-lightbox';
      ov.innerHTML = '<div class="bm-lb-bg"></div>' +
        '<div class="bm-lb-frame"><img alt="" class="bm-lb-img"></div>' +
        '<button class="bm-lb-prev" title="' + esc(T('search.nav_prev', 'Previous (←)')) + '">‹</button>' +
        '<button class="bm-lb-next" title="' + esc(T('search.nav_next', 'Next (→)')) + '">›</button>' +
        '<button class="bm-lb-close" title="' + esc(T('search.nav_close', 'Close (Esc)')) + '">×</button>' +
        '<div class="bm-lb-counter"></div>';
      document.body.appendChild(ov);
      var img = ov.querySelector('.bm-lb-img');
      var ctr = ov.querySelector('.bm-lb-counter');
      function show() {
        var it = items[idx];
        img.src = it.signed_url || '';
        ctr.textContent = (idx + 1) + ' / ' + items.length + (it.label ? ' · ' + it.label : '');
      }
      function next() { idx = (idx + 1) % items.length; show(); }
      function prev() { idx = (idx - 1 + items.length) % items.length; show(); }
      function close() { document.removeEventListener('keydown', onKey); ov.remove(); }
      function onKey(e) {
        if (e.key === 'Escape') { e.preventDefault(); close(); }
        else if (e.key === 'ArrowRight' || e.key === 'Tab') { e.preventDefault(); next(); }
        else if (e.key === 'ArrowLeft') { e.preventDefault(); prev(); }
      }
      document.addEventListener('keydown', onKey);
      ov.querySelector('.bm-lb-prev').addEventListener('click', prev);
      ov.querySelector('.bm-lb-next').addEventListener('click', next);
      ov.querySelector('.bm-lb-close').addEventListener('click', close);
      ov.querySelector('.bm-lb-bg').addEventListener('click', close);
      show();
    }
    // Plan §33.4 — format a timestamp for download-status tooltip / sub-label.
    // Renders YYYY-MM-DD via toLocaleDateString so the shopify storefront
    // matches the user's browser locale without bundling a date library.
    function fmtDownloadDate(ts) {
      if (!ts) return '';
      try {
        var d = new Date(String(ts).replace(' ', 'T'));
        if (isNaN(d.getTime())) return '';
        return d.toLocaleDateString();
      } catch (e) { return ''; }
    }
    // Plan §33.4 — silent re-fetch of the library endpoint after a download
    // click so the freshly-recorded download surfaces a green tick without
    // a page-refresh. Debounced 800ms; multiple rapid clicks coalesce.
    var libRefreshTimer = null;
    function scheduleLibraryRefresh() {
      if (libRefreshTimer) clearTimeout(libRefreshTimer);
      libRefreshTimer = setTimeout(function () {
        libRefreshTimer = null;
        fetch(proxyUrl, { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' })
          .then(function (r) { return r.json(); })
          .then(function (j) {
            try {
              var rl = (j && j.data && Array.isArray(j.data.releases)) ? j.data.releases : null;
              if (!rl) return;
              state.releases = rl;
              state.releaseByDir = {}; state.releaseById = {};
              rl.forEach(function (r) {
                if (!r) return;
                if (r.release_dir) state.releaseByDir[r.release_dir] = r;
                if (r.cloud_release_id) state.releaseById[r.cloud_release_id] = r;
              });
              renderResults();
            } catch (e) { /* swallow — refresh is best-effort */ }
          })
          .catch(function () { /* same */ });
      }, 800);
    }
    // Plan §27 — Releases-view filter. A release passes when:
    //   - text matches its display name / release_dir, AND
    //   - at least one of its scenes matches every active facet.
    // Without the scene-side check the sidebar facets (biome, adventure) would
    // appear active but have no visible effect at the release level.
    // Tag-aware free-text haystack for a release: name + dir + adventures +
    // every scene's biome / adventure / type / brightness. Lets the search bar
    // find releases by content tags, not just by their title.
    function releaseFacetVals(r, key) {
      var fac = (r && r.facets) || {};
      var v = fac[key];
      return Array.isArray(v) ? v : [];
    }
    // A release matches when its aggregated facet set contains at least one of
    // the selected values per active facet (AND across facets, OR within one).
    function releaseMatchesFacets(r, fBiom, fAdv, fType, fBri, fGrid) {
      if (fBiom.length && !releaseFacetVals(r, 'biom').some(function (b) { return fBiom.indexOf(b) >= 0; })) return false;
      if (fAdv.length && !releaseFacetVals(r, 'adventure').some(function (a) { return fAdv.indexOf(a) >= 0; })) return false;
      if (fType.length && !releaseFacetVals(r, 'type').some(function (t) { return fType.indexOf(t) >= 0; })) return false;
      if (fBri.length && !releaseFacetVals(r, 'brightness').some(function (b) { return fBri.indexOf(b) >= 0; })) return false;
      if (fGrid.length && !releaseFacetVals(r, 'grid').some(function (g) { return fGrid.indexOf(g) >= 0; })) return false;
      return true;
    }
    function releaseSearchTags(r) {
      // Tag-aware free-text haystack: name + dir is added by the caller; here we
      // add every aggregated facet value (biome / adventure / type / brightness /
      // grid) so the search bar finds releases by content tags, not just title.
      var parts = [];
      ['biom', 'adventure', 'type', 'brightness', 'grid'].forEach(function (k) {
        releaseFacetVals(r, k).forEach(function (v) { if (v) parts.push(v); });
      });
      // hidden_tags: search-only synonyms from the catalog admin. Part of the
      // haystack, never rendered anywhere.
      (Array.isArray(r.hidden_tags) ? r.hidden_tags : []).forEach(function (v) { if (v) parts.push(v); });
      return parts.join(' ');
    }
    function releaseFiltered() {
      var list = state.releases || [];
      var f = state.filters.battlemap || {};
      var q = (f._q || '').trim().toLowerCase();
      var fBiom = Array.isArray(f.biom) ? f.biom : [];
      var fAdv  = Array.isArray(f.adventure) ? f.adventure : [];
      var fType = Array.isArray(f.type) ? f.type : [];
      var fBri  = Array.isArray(f.brightness) ? f.brightness : [];
      var fGrid = Array.isArray(f.grid) ? f.grid : [];
      var hasFacets = fBiom.length || fAdv.length || fType.length || fBri.length || fGrid.length;
      var hasPerm = Array.isArray(f._perm) && f._perm.length === 1;
      // Plan §49.F: newest on top by default; sortReleases honors state.sort.
      if (!hasFacets && !q && !hasPerm) return sortReleases(list);
      var filtered = list.filter(function (r) {
        if (hasPerm && !permPass(f, releaseHasAccess(r))) return false;
        if (q) {
          var hay = ((r.display_name || '') + ' ' + (r.release_dir || '') + ' ' + releaseSearchTags(r)).toLowerCase();
          if (hay.indexOf(q) === -1) return false;
        }
        if (!hasFacets) return true;
        return releaseMatchesFacets(r, fBiom, fAdv, fType, fBri, fGrid);
      });
      return sortReleases(filtered);
    }
    function releaseCoverUrl(r) {
      if (!r) return null;
      // app-proxy.php currently emits a single cover_url field (variant-
      // agnostic). Kept fallbacks for forward-compat if the backend ever
      // splits 4K / HD covers.
      return r.cover_url || r.cover_url_4k || r.cover_url_hd || null;
    }

    // Plan §19.5 Phase A2 / §27 — flatten state.releases[].scenes into a per-scene
    // list for the Individual-Maps view. Only releases with at least one
    // available_downloads entry contribute (= "your accessible scenes").
    // §27: pass every scene field through (thumbnail, sibling_*, biom, adventure,
    // brightness, type, grid) so card-render + filter-engine see the full shape.
    function individualMapItems() {
      // Plan §48.A — show every scene the catalog has, regardless of the
      // user's entitlement state. Lock state is communicated via the drawer
      // when the user clicks; pre-filtering by available_downloads hides
      // 80%+ of the library and yields a broken "no scenes yet" experience.
      var out = [];
      (state.releases || []).forEach(function (r) {
        if (!r || !Array.isArray(r.scenes)) return;
        r.scenes.forEach(function (s) {
          var item = {};
          for (var k in s) { if (Object.prototype.hasOwnProperty.call(s, k)) item[k] = s[k]; }
          item._release = r;
          if (!item.name) item.name = s.scene_slug || s.scene_dir;
          out.push(item);
        });
      });
      return out;
    }
    // Plan §27 — facet-aware filter for the Individual-Maps view. Reads
    // state.filters.battlemap.{biom, adventure, type, brightness} and applies
    // them against the catalog-embedded per-scene properties (§27 backend
    // emission). Multi-value facets (biom, adventure) match if intersection
    // is non-empty; single-value facets (type, brightness) match if the
    // scene value is in the active set.
    function individualMapFiltered() {
      var list = individualMapItems();
      var f = state.filters.battlemap || {};
      var q = (f._q || '').trim().toLowerCase();
      var fBiom = Array.isArray(f.biom) ? f.biom : [];
      var fAdv  = Array.isArray(f.adventure) ? f.adventure : [];
      var fType = Array.isArray(f.type) ? f.type : [];
      var fBri  = Array.isArray(f.brightness) ? f.brightness : [];
      var fGrid = Array.isArray(f.grid) ? f.grid : [];
      var filtered = list.filter(function (s) {
        var rel = s._release || {};
        if (!permPass(f, releaseHasAccess(rel))) return false;
        if (q) {
          // Scene name + parent release name + the release's aggregated facet
          // tags (per-scene catalog fields are unreliable, so inherit them).
          var hay = ((s.name || '') + ' ' + (rel.display_name || '') + ' ' + releaseSearchTags(rel)).toLowerCase();
          if (hay.indexOf(q) === -1) return false;
        }
        // Scenes inherit their parent release's facets (release-level filtering).
        return releaseMatchesFacets(rel, fBiom, fAdv, fType, fBri, fGrid);
      });
      // Plan §52.B: scenes carry no own date, so recency comes from the parent
      // release. Group band + inner order follow the toolbar sort mode; in
      // 'new' mode the stable Array.sort keeps all scenes of a release
      // together and preserves intra-release order.
      return filtered.sort(function (a, b) {
        var g = releaseGroupRank(a._release) - releaseGroupRank(b._release);
        if (g) return g;
        var an = String(a.name || ''), bn = String(b.name || '');
        if (state.sort === 'name' || state.sort === 'owned') return an.localeCompare(bn);
        if (state.sort === 'cr') {
          var aa = gridArea(a.grid); if (aa == null) aa = releaseMaxGridArea(a._release);
          var bb = gridArea(b.grid); if (bb == null) bb = releaseMaxGridArea(b._release);
          return cmpNullsLast(aa, bb) || an.localeCompare(bn);
        }
        return releaseRecencyCmp(a._release, b._release);
      });
    }

    // Pagination footer. With IntersectionObserver we render a small spinner
    // sentinel and (re)observe it so the next page auto-loads on scroll; without
    // it we fall back to a clickable "Load more" button. A FRESH sentinel each
    // render is required: re-observing a persistent node never re-fires once it
    // is already in view, so the list would stall after the first page.
    var moreObserver = null;
    function renderMore(moreEl, total) {
      state.hasMore = total > state.visible;
      if (moreObserver) moreObserver.disconnect();
      if (!state.hasMore) { moreEl.innerHTML = ''; return; }
      if (!('IntersectionObserver' in window)) {
        moreEl.innerHTML = '<button class="btn ghost">Load more (' + (total - state.visible) + ')</button>';
        return;
      }
      moreEl.innerHTML = '<div class="brw-more-load" aria-hidden="true"><span class="bm-tile-spin"></span></div>';
      if (!moreObserver) {
        moreObserver = new IntersectionObserver(function (entries) {
          if (entries[0] && entries[0].isIntersecting && state.hasMore) { state.visible += PAGE; renderResults(); }
        }, { root: null, rootMargin: '800px 0px' });
      }
      moreObserver.observe(moreEl.firstChild);
    }

    function renderResults() {
      var wrap = root.querySelector('[data-results]');
      // Reset each render; renderMore() re-arms it when another page exists, so
      // empty-state branches never leave the infinite-scroll observer firing.
      state.hasMore = false;

      // Plan §19.5 — Releases view: render one card per release with
      // available_downloads count badge. Click opens release-drawer.
      if (state.kind === 'battlemap' && state.bmapView === 'releases') {
        var rAll = releaseFiltered();
        root.querySelector('[data-count]').innerHTML = '<b>' + rAll.length + '</b> / ' + (state.releases || []).length + ' releases';
        var rShown = rAll.slice(0, state.visible);
        if (!rAll.length) {
          wrap.innerHTML = '<div class="brw-empty"><h3>No releases match</h3><p>Try clearing the filters in the sidebar. Every release offers a free static-map download; a Patreon tier or shop purchase unlocks the full animated packs.</p></div>';
          root.querySelector('[data-more]').innerHTML = '';
          return;
        }
        // Plan §33.4 — download-state helpers (reused in Grid + List).
        var dlInfo = function (r) {
          var st = r.release_download_state || {};
          // app-proxy emits has_any_download (not has_any) — reading the wrong
          // key was why the per-release tick never showed in Grid OR List.
          if (!st.has_any_download) return null;
          var stale = !!st.is_any_stale;
          var dateStr = fmtDownloadDate(st.last_downloaded_at);
          var variantStr = st.last_variant || '';
          var tip = T('search.dl_downloaded', 'Downloaded') + ' ' + (dateStr || T('search.dl_previously', 'previously')) + (variantStr ? ' (' + variantStr + ')' : '') + '.' +
            (stale ? ' ' + T('search.dl_stale', 'Release was updated since your download.') : '');
          return { stale: stale, date: dateStr, tip: tip };
        };
        // A large green check next to the release title (date lives in the
        // tooltip only — the inline text was too small to read). Stale shows a
        // gold "!" instead.
        var dlBadgeHtml = function (r) {
          var i = dlInfo(r); if (!i) return '';
          return '<span class="dl-check ' + (i.stale ? 'stale' : 'fresh') + '" title="' + esc(i.tip) + '">' + (i.stale ? '!' : '✓') + '</span>';
        };
        if (state.view === 'list') {
          wrap.innerHTML = '<table class="tbl"><thead><tr><th>Release</th><th>Content</th><th>Size</th><th>Downloads</th><th></th></tr></thead><tbody>' +
            rShown.map(function (r) {
              var cov = releaseCoverUrl(r);
              // Plan §23 W2.1: count only ACTIVE downloads for the card badge.
              var dlN = (r.available_downloads || []).filter(function(d){return d.state !== 'locked';}).length;
              var badge = dlBadgeHtml(r);
              // Plan §46.3 — release-stats line + bytes-total + trailer badge.
              var statsTxt = releaseStatsLine(r) || ((r.scene_count || 0) + ' scenes');
              var sizeTxt  = r.bytes_total ? humanBytes(r.bytes_total) : '';
              var trailer  = releaseHasTrailer(r) ? ' <span class="rls-badge" title="' + esc(T('search.trailer', 'Trailer available')) + '">▶</span>' : '';
              return '<tr data-open-release="' + esc(r.cloud_release_id || r.release_dir) + '"><td><div class="row-thumb"><div class="th' + (cov ? ' is-loading' : '') + '">' +
                (cov ? '<img loading="lazy" data-src="' + esc(cov) + '" alt=""><span class="bm-tile-spin" aria-hidden="true"></span>' : esc((r.display_name || '?').slice(0, 1))) +
                '</div><div class="meta"><div class="nm">' + esc(r.display_name || r.release_dir) + trailer + (badge ? ' ' + badge : '') + '</div>' +
                '<div class="row-sub">' + (r.release_num ? 'Release ' + esc(r.release_num) : '') + '</div></div></div></td>' +
                '<td>' + esc(statsTxt) + '</td>' +
                '<td>' + esc(sizeTxt) + '</td>' +
                '<td>' + (dlN ? dlN + ' available' : '<span style="color:var(--ink-dim)">Locked</span>') + '</td>' +
                '<td class="r"><button class="btn xs primary" data-open-release="' + esc(r.cloud_release_id || r.release_dir) + '">' + SVG.dl + '</button></td></tr>';
            }).join('') + '</tbody></table>';
        } else {
          // Plan §48.C — minimal release card per user spec:
          // cover · title · size · adventure chips ("Compatible with X") · lock-state.
          // Segmented like creatures/items/spells: free/accessible releases on
          // top (green), locked Patreon/shop releases below with a CTA band.
          // Battlemaps are never fully locked (every release ships the free
          // static-map ZIP). So we segment by COMPLETE-pack availability:
          // "Free complete packs" (the 4 free releases, green) vs "Premium packs"
          // (full animated pack behind a membership, static maps still free).
          var relCard = function (r) {
            var cov = releaseCoverUrl(r);
            var isFree = !!r.is_free;
            var sizeTxt  = r.bytes_total ? humanBytes(r.bytes_total) : '';
            var advs = releaseAdventures(r);
            var advChips = advs.slice(0, 4).map(function (a) {
              return '<span class="rls-adv-chip" title="Compatible with ' + esc(a) + '">' + esc(adventureAcronym(a)) + '</span>';
            }).join('');
            var dlCheck = dlBadgeHtml(r);
            var ownedFor = !!r.can_download_zip; // permanent ownership (purchase/shopify/loyalty/gift)
            return '<article class="acard' + (isFree ? ' free' : '') + (ownedFor ? ' owned-forever' : '') + '" data-open-release="' + esc(r.cloud_release_id || r.release_dir) + '">' +
              '<div class="acard-thumb' + (cov ? ' is-loading' : '') + '" data-aspect="wide">' +
                (cov ? '<img loading="lazy" data-src="' + esc(cov) + '" alt=""><span class="bm-tile-spin" aria-hidden="true"></span>' : '<span class="glyph" aria-hidden="true">' + esc((r.display_name || '?').slice(0, 1)) + '</span>') +
                '<div class="acard-perm">' + relPermChip(r) + '</div>' +
                '<button class="acard-dl" data-open-release="' + esc(r.cloud_release_id || r.release_dir) + '" title="Show downloads">' + SVG.dl + '</button>' +
              '</div>' +
              '<div class="acard-body">' +
                '<div class="acard-name">' + esc(r.display_name || r.release_dir) + (dlCheck ? ' ' + dlCheck : '') + '</div>' +
                (sizeTxt ? '<div class="acard-sub">' + esc(sizeTxt) + '</div>' : '') +
                (advChips ? '<div class="rls-adv-line">' + advChips + '</div>' : '') +
              '</div></article>';
          };
          // Divider counts show the FULL group total (rAll), not just the
          // paginated slice, so "Premium packs (N)" never understates the catalog.
          // Groups must mirror releaseGroupRank, or the headers would contradict
          // the sort order in 'owned' mode (which regroups by access).
          var ownedMode = state.sort === 'owned';
          var inTopR = function (r) { return releaseGroupRank(r) === 0; };
          var accAll = rAll.filter(inTopR);
          var premAll = rAll.filter(function (r) { return !inTopR(r); });
          var accR = rShown.filter(inTopR);
          var premR = rShown.filter(function (r) { return !inTopR(r); });
          var rh = '<div class="grid maps-view kind-battlemap segmented">';
          if (accAll.length) {
            rh += accessBandHead(ownedMode ? T('search.band_your_packs', 'Your packs') : T('search.band_free_packs', 'Free complete packs'), accAll.length) + accR.map(relCard).join('');
          }
          if (premAll.length) {
            rh += premiumBandHead(premAll.length, ownedMode, T('search.band_locked_packs', 'Locked packs')) + premR.map(relCard).join('');
          }
          rh += '</div>';
          wrap.innerHTML = rh;
        }
        // Plan §70.A — IntersectionObserver-driven lazy load with spinner.
        attachLazyImages(wrap);
        renderMore(root.querySelector('[data-more]'), rAll.length);
        return;
      }

      // Plan §19.5 Phase A2 — Individual-Maps view: flat per-scene cards
      // sourced from state.releases[].scenes (only releases the user has
      // available_downloads for contribute). Click resolves to the parent
      // release drawer because downloads are release-scoped, not scene-scoped.
      if (state.kind === 'battlemap' && state.bmapView === 'individual') {
        var iAll = individualMapFiltered();
        var iTotal = individualMapItems().length;
        root.querySelector('[data-count]').innerHTML = '<b>' + iAll.length + '</b> / ' + iTotal + ' map' + (iTotal === 1 ? '' : 's');
        var iShown = iAll.slice(0, state.visible);
        if (!iAll.length) {
          // Plan §47.2 — differentiated empty-state. Three distinct cases so the
          // user can act on the message instead of staring at a generic placeholder.
          var fBM = state.filters.battlemap || {};
          var hasFilters = (fBM._q && fBM._q.trim()) ||
            (fBM.biom && fBM.biom.length) || (fBM.adventure && fBM.adventure.length) ||
            (fBM.type && fBM.type.length) || (fBM.brightness && fBM.brightness.length);
          var nRel = (state.releases || []).length;
          var nDl  = (state.releases || []).filter(function (r) { return r && Array.isArray(r.available_downloads) && r.available_downloads.length; }).length;
          var msg;
          if (hasFilters && nRel > 0) {
            msg = T('search.empty_filtered_html', '<h3>No scenes match your filters</h3><p>Try clearing biome, adventure, type or brightness in the sidebar, or switch to the Releases view for a full library overview.</p>');
          } else if (nRel === 0) {
            msg = T('search.empty_none_html', '<h3>No releases available yet</h3><p>You currently have no battlemap releases in your library. Pledge on Patreon or buy in the shop to unlock content.</p>');
          } else if (nDl === 0) {
            msg = '<h3>' + T('search.empty_nodl_h', 'Releases visible but no downloads') + '</h3><p>' + T('search.empty_nodl_pre', 'You can see') + ' ' + nRel + ' ' + T((nRel === 1 ? 'search.release_one' : 'search.release_many'), (nRel === 1 ? 'release' : 'releases')) + ' ' + T('search.empty_nodl_post', 'but none have downloadable scenes yet. They may still be processing on the cloud, so refresh in a minute.') + '</p>';
          } else {
            msg = T('search.empty_noscenes_html', '<h3>No individual scenes yet</h3><p>The releases you have access to do not list any scenes. This is usually a temporary processing state, so try the Releases view for a top-level overview.</p>');
          }
          wrap.innerHTML = '<div class="brw-empty">' + msg + '</div>';
          root.querySelector('[data-more]').innerHTML = '';
          return;
        }
        if (state.view === 'list') {
          wrap.innerHTML = '<table class="tbl"><thead><tr><th>Scene</th><th>Release</th><th></th></tr></thead><tbody>' +
            iShown.map(function (s) {
              var rel = s._release;
              // Plan §26 — prefer the per-scene thumbnail (cluster028 CDN);
              // fall back to the release-cover if the catalog has no entry.
              var cov = s.thumbnail || releaseCoverUrl(rel);
              return '<tr data-open-release="' + esc(rel.cloud_release_id || rel.release_dir) + '" data-scene-slug="' + esc(s.scene_slug || '') + '">' +
                '<td><div class="row-thumb"><div class="th' + (cov ? ' is-loading' : '') + '">' +
                  (cov ? '<img loading="lazy" data-src="' + esc(cov) + '" alt=""><span class="bm-tile-spin" aria-hidden="true"></span>' : esc((s.name || '?').slice(0, 1))) +
                '</div><div class="meta"><div class="nm">' + esc(s.name) + '</div></div></div></td>' +
                '<td>' + esc(rel.display_name || rel.release_dir) + '</td>' +
                '<td class="r"><button class="btn xs primary" data-open-release="' + esc(rel.cloud_release_id || rel.release_dir) + '" data-scene-slug="' + esc(s.scene_slug || '') + '">' + SVG.dl + '</button></td></tr>';
            }).join('') + '</tbody></table>';
        } else {
          var sceneCard = function (s) {
            var rel = s._release;
            // Plan §26 — prefer the per-scene thumbnail (cluster028 CDN);
            // fall back to the release-cover if the catalog has no entry.
            var cov = s.thumbnail || releaseCoverUrl(rel);
            var isFree = !!(rel && rel.is_free);
            var ownedFor = !!(rel && rel.can_download_zip);
            return '<article class="acard' + (isFree ? ' free' : '') + (ownedFor ? ' owned-forever' : '') + '" data-open-release="' + esc(rel.cloud_release_id || rel.release_dir) + '" data-scene-slug="' + esc(s.scene_slug || '') + '">' +
              '<div class="acard-thumb' + (cov ? ' is-loading' : '') + '" data-aspect="wide">' +
                (cov ? '<img loading="lazy" data-src="' + esc(cov) + '" alt=""><span class="bm-tile-spin" aria-hidden="true"></span>' : '<span class="glyph" aria-hidden="true">' + esc((s.name || '?').slice(0, 1)) + '</span>') +
                '<div class="acard-perm">' + relPermChip(rel) + '</div>' +
                '<button class="acard-dl" data-open-release="' + esc(rel.cloud_release_id || rel.release_dir) + '" data-scene-slug="' + esc(s.scene_slug || '') + '" title="Show release downloads">' + SVG.dl + '</button>' +
              '</div>' +
              '<div class="acard-body"><div class="acard-name">' + esc(s.name) + '</div>' +
                '<div class="acard-sub">' + esc(rel.display_name || rel.release_dir) + '</div>' +
              '</div></article>';
          };
          // Divider counts = full group totals (iAll), cards = paginated slice.
          // Groups mirror releaseGroupRank (access-based bands in 'owned' mode).
          var ownedModeI = state.sort === 'owned';
          var inTopI = function (s) { return releaseGroupRank(s._release) === 0; };
          var accIAll = iAll.filter(inTopI);
          var premIAll = iAll.filter(function (s) { return !inTopI(s); });
          var accI = iShown.filter(inTopI);
          var premI = iShown.filter(function (s) { return !inTopI(s); });
          var ih = '<div class="grid maps-view kind-battlemap segmented">';
          if (accIAll.length) {
            ih += accessBandHead(ownedModeI ? T('search.band_your_maps', 'Your maps') : T('search.band_free_packs', 'Free complete packs'), accIAll.length) + accI.map(sceneCard).join('');
          }
          if (premIAll.length) {
            ih += premiumBandHead(premIAll.length, ownedModeI, T('search.band_locked_maps', 'Locked maps')) + premI.map(sceneCard).join('');
          }
          ih += '</div>';
          wrap.innerHTML = ih;
        }
        // Plan §70.A — IntersectionObserver-driven lazy load with spinner.
        attachLazyImages(wrap);
        renderMore(root.querySelector('[data-more]'), iAll.length);
        return;
      }

      // Plan §72.4 - Bundles view: list install_bundles, one card per bundle.
      // Click opens bundle-drawer with per-sub-release download buttons + a
      // "Download All" cascade.
      if (state.kind === 'battlemap' && state.bmapView === 'bundles') {
        var bAll = state.bundles || [];
        // Apply text-search on bundle name/description so the existing search
        // bar still narrows the list.
        var fbq = ((state.filters.battlemap || {})._q || '').trim().toLowerCase();
        if (fbq) {
          bAll = bAll.filter(function (b) {
            var hay = ((b.name || '') + ' ' + (b.description || '') + ' ' + (b.slug || '')).toLowerCase();
            return hay.indexOf(fbq) !== -1;
          });
        }
        // Bundles carry no own date; recency proxy = highest member-release
        // number, size = bytes_total, access = any accessible member release.
        var bName = function (b) { return String(b.name || b.slug || ''); };
        var bNum = function (b) {
          var best = null;
          (b.members || []).forEach(function (m) {
            var r = state.releaseById && state.releaseById[m.asset_id];
            if (r) { var n = releaseNumKey(r); if (best == null || n > best) best = n; }
          });
          return best;
        };
        // Access-chip filter also applies to bundles (accessible = any member
        // release unlocked).
        bAll = bAll.filter(function (b) { return permPass(state.filters.battlemap, bundleHasAccess(b)); });
        bAll = bAll.slice().sort(function (a, b) {
          if (state.sort === 'owned') return ((bundleHasAccess(a) ? 0 : 1) - (bundleHasAccess(b) ? 0 : 1)) || bName(a).localeCompare(bName(b));
          if (state.sort === 'name') return bName(a).localeCompare(bName(b));
          if (state.sort === 'cr') return cmpNullsLast(a.bytes_total, b.bytes_total) || bName(a).localeCompare(bName(b));
          return cmpNullsLast(bNum(a), bNum(b)) || bName(a).localeCompare(bName(b));
        });
        root.querySelector('[data-count]').innerHTML = '<b>' + bAll.length + '</b> / ' + ((state.bundles || []).length) + ' bundles';
        var bShown = bAll.slice(0, state.visible);
        if (!bAll.length) {
          wrap.innerHTML = '<div class="brw-empty"><h3>No bundles yet</h3><p>Install bundles group multiple releases into one install package. None published yet.</p></div>';
          root.querySelector('[data-more]').innerHTML = '';
          return;
        }
        if (state.view === 'list') {
          wrap.innerHTML = '<table class="tbl"><thead><tr><th>Bundle</th><th>Members</th><th>Size</th><th></th></tr></thead><tbody>' +
            bShown.map(function (b) {
              var cov = b.cover_url || (b.members && b.members[0] ? releaseCoverUrl(state.releaseById[b.members[0].asset_id] || {}) : '');
              var sizeTxt = b.bytes_total ? humanBytes(b.bytes_total) : '';
              return '<tr data-open-bundle="' + esc(b.id) + '"><td><div class="row-thumb"><div class="th' + (cov ? ' is-loading' : '') + '">' +
                (cov ? '<img loading="lazy" data-src="' + esc(cov) + '" alt=""><span class="bm-tile-spin" aria-hidden="true"></span>' : esc((b.name || '?').slice(0, 1))) +
                '</div><div class="meta"><div class="nm">' + esc(b.name || b.slug) + '</div>' +
                '<div class="row-sub">' + (b.description ? esc(String(b.description).slice(0, 120)) : '') + '</div></div></div></td>' +
                '<td>' + (b.member_count || 0) + ' releases</td>' +
                '<td>' + esc(sizeTxt) + '</td>' +
                '<td class="r"><button class="btn xs primary" data-open-bundle="' + esc(b.id) + '" title="Open bundle drawer">' + SVG.dl + '</button></td></tr>';
            }).join('') + '</tbody></table>';
        } else {
          wrap.innerHTML = '<div class="grid maps-view kind-battlemap">' +
            bShown.map(function (b) {
              var cov = b.cover_url || (b.members && b.members[0] ? releaseCoverUrl(state.releaseById[b.members[0].asset_id] || {}) : '');
              var sizeTxt = b.bytes_total ? humanBytes(b.bytes_total) : '';
              return '<article class="acard bundle-card" data-open-bundle="' + esc(b.id) + '">' +
                '<div class="acard-thumb' + (cov ? ' is-loading' : '') + '" data-aspect="wide">' +
                  (cov ? '<img loading="lazy" data-src="' + esc(cov) + '" alt=""><span class="bm-tile-spin" aria-hidden="true"></span>' : '<span class="glyph" aria-hidden="true">' + esc((b.name || '?').slice(0, 1)) + '</span>') +
                  '<div class="acard-bundle-badge">' + (b.member_count || 0) + ' Releases</div>' +
                  '<button class="acard-dl" data-open-bundle="' + esc(b.id) + '" title="Open bundle">' + SVG.dl + '</button>' +
                '</div>' +
                '<div class="acard-body">' +
                  '<div class="acard-name">' + esc(b.name || b.slug) + '</div>' +
                  (sizeTxt ? '<div class="acard-sub">' + esc(sizeTxt) + ' across ' + (b.member_count || 0) + ' release' + ((b.member_count || 0) === 1 ? '' : 's') + '</div>' : '') +
                '</div></article>';
            }).join('') + '</div>';
        }
        attachLazyImages(wrap);
        renderMore(root.querySelector('[data-more]'), bAll.length);
        return;
      }

      var all = filtered();
      root.querySelector('[data-count]').innerHTML = '<b>' + all.length + '</b> / ' + (state.data[state.kind] || []).length + ' ' + FACETS[state.kind].tab.toLowerCase();
      var shown = all.slice(0, state.visible);
      var aspect = FACETS[state.kind].aspect;
      if (!all.length) { wrap.innerHTML = '<div class="brw-empty"><h3>No matches</h3><p>Try removing a filter or broadening your search.</p></div>'; root.querySelector('[data-more]').innerHTML = ''; return; }
      if (state.view === 'list') {
        wrap.innerHTML = '<table class="tbl"><thead><tr><th>Name</th><th>Access</th><th></th></tr></thead><tbody>' +
          shown.map(function (it) {
            return '<tr data-open="' + esc(it.key) + '"><td><div class="row-thumb"><div class="th' + (it.thumb ? ' is-loading' : '') + '"' + thumbStyle(it) + '>' + (it.thumb ? '<img loading="lazy" data-src="' + esc(it.thumb) + '" alt=""><span class="bm-tile-spin" aria-hidden="true"></span>' : esc(it.name.slice(0, 1))) + '</div><div class="meta"><div class="nm">' + esc(it.name) + '</div><div class="row-sub">' + esc(subFor(it)) + '</div></div></div></td>' +
              '<td>' + (it.perm === 'locked' ? permChip(it.perm) : '') + '</td>' +
              '<td class="r">' + actionBtn(it) + '</td></tr>';
          }).join('') + '</tbody></table>';
      } else {
        // Segmented grid (mirrors the Foundry module): a green "Free & unlocked"
        // band on top, then a "Patreon & shop content" band with a become-a-patron
        // CTA. Free cards carry a green accent so they read as free at a glance.
        var card = function (it) {
          var locked = it.perm === 'locked';
          var isFree = it.perm === 'free';
          return '<article class="acard' + (locked ? ' locked' : (isFree ? ' free' : '')) + (it.ownedPerm ? ' owned-forever' : '') + '" data-open="' + esc(it.key) + '">' +
            '<div class="acard-thumb' + (it.thumb ? ' is-loading' : '') + '" data-aspect="' + aspect + '"' + thumbStyle(it) + '>' +
              (it.thumb ? '<img loading="lazy" data-src="' + esc(it.thumb) + '" alt=""><span class="bm-tile-spin" aria-hidden="true"></span>' : '<span class="glyph" aria-hidden="true">' + esc(it.name.slice(0, 1)) + '</span>') +
              (locked ? '<div class="acard-perm">' + permChip(it.perm) + '</div>' : (it.ownedPerm ? '<div class="acard-perm">' + ownedForeverChip() + '</div>' : (isFree ? '<div class="acard-perm">' + permChip('free') + '</div>' : ''))) +
              '<button class="acard-dl' + (locked ? ' locked' : '') + '" data-act="' + esc(it.key) + '" title="' + (locked ? 'Get access' : 'Download') + '">' + (locked ? SVG.lock : SVG.dl) + '</button>' +
            '</div>' +
            '<div class="acard-body"><div class="acard-name">' + esc(it.name) + '</div><div class="acard-sub">' + esc(subFor(it)) + '</div>' +
              ((it.tags && it.tags.length) ? '<div class="acard-tags">' + it.tags.slice(0, 3).map(function (t) { return '<span class="tag">' + esc(t) + '</span>'; }).join('') + '</div>' : '') +
            '</div></article>';
        };
        // Divider counts = full group totals (all), cards = paginated slice.
        var accAllG = all.filter(function (it) { return it.perm !== 'locked'; });
        var lockAllG = all.filter(function (it) { return it.perm === 'locked'; });
        var acc = shown.filter(function (it) { return it.perm !== 'locked'; });
        var lock = shown.filter(function (it) { return it.perm === 'locked'; });
        var gridHtml = '<div class="grid cards-view kind-' + state.kind + ' segmented">';
        if (accAllG.length) {
          gridHtml += '<div class="brw-group-h free"><span class="gh-t">Free &amp; unlocked content</span><span class="gh-n">' + accAllG.length + '</span></div>' + acc.map(card).join('');
        }
        if (lockAllG.length) {
          gridHtml += '<div class="brw-group-h locked">' +
              '<div class="gh-meta"><span class="gh-t">Patreon &amp; shop content</span><span class="gh-n">' + lockAllG.length + '</span></div>' +
              '<div class="gh-cta"><span class="gh-cta-txt">Locked content. Unlock it with a Beneos membership.</span>' +
                '<a class="btn xs primary" href="' + esc(patreonUrl) + '" target="_blank" rel="noopener">Become a patron</a>' +
                '<a class="btn xs ghost" href="' + esc(shopUrl) + '">Browse shop</a>' +
              '</div>' +
            '</div>' + lock.map(card).join('');
        }
        gridHtml += '</div>';
        wrap.innerHTML = gridHtml;
      }
      // Plan §70.A — IntersectionObserver-driven lazy load with spinner.
      attachLazyImages(wrap);
      renderMore(root.querySelector('[data-more]'), all.length);
    }

    function thumbStyle(it) {
      if (it.thumb) return '';
      var h = 0, s = it.key; for (var i = 0; i < s.length; i++) h = (h * 31 + s.charCodeAt(i)) % 360;
      return ' style="--c1:oklch(0.42 0.09 ' + h + ');--c2:oklch(0.15 0.03 ' + ((h + 40) % 360) + ')"';
    }
    function subFor(it) {
      var p = it.props;
      if (it.kind === 'token') return typeStr(p) + (p.cr != null ? ' · CR ' + p.cr : '');
      if (it.kind === 'battlemap') return (p.type || T('search.label_battlemap', 'Battlemap')) + (p.download_pack ? ' · ' + p.download_pack : '');
      if (it.kind === 'spell') return (p.school || '') + (p.level != null ? ' · ' + T('search.lvl_abbr', 'Lvl') + ' ' + p.level : '');
      if (it.kind === 'item') return (p.item_type || '') + (p.rarity ? ' · ' + p.rarity : '');
      return '';
    }
    function permChip(perm) {
      var label = { shop: T('search.perm_owned', 'Owned'), backlog: T('search.perm_backlog', 'In your tier'), loyalty: T('search.perm_loyalty', 'Loyalty'), reward: T('search.perm_reward', 'Reward'), free: T('search.perm_free', 'Free'), locked: T('search.access_locked', 'Locked') }[perm] || perm;
      var ic = perm === 'locked' ? SVG.lock : '';
      return '<span class="perm-chip ' + perm + '">' + ic + esc(label) + '</span>';
    }
    function actionBtn(it) {
      if (it.perm === 'locked') return '<button class="btn xs ghost" data-act="' + esc(it.key) + '">' + SVG.lock + ' Get</button>';
      // Phase 4.6 paywall: battlemap entitlements that come from a Patreon tier do not
      // unlock the raw ZIP download. The user can still install via the Foundry module;
      // we surface that explicitly instead of rendering a misleading download button.
      if (it.kind === 'battlemap' && it.canDownloadZip === false) {
        return '<span class="btn xs ghost" title="Patreon access unlocks the install path in the Foundry module. Shop purchases also unlock the ZIP download." style="cursor:default">Install in Foundry</span>';
      }
      return '<button class="btn xs primary" data-act="' + esc(it.key) + '">' + SVG.dl + '</button>';
    }

    // ---------- interactions ----------
    function findItem(key) { return (state.data[state.kind] || []).filter(function (i) { return i.key === key; })[0]; }

    function onClick(e) {
      var t = e.target;
      var reset = t.closest('[data-reset]'); if (reset) { state.filters[state.kind] = emptyFilters(state.kind); var qi = root.querySelector('[data-q]'); if (qi) qi.value = ''; render(); return; }
      var perm = t.closest('[data-perm]'); if (perm) { toggleArr(state.filters[state.kind], '_perm', perm.getAttribute('data-perm')); render(); return; }
      var srcBtn = t.closest('[data-src]'); if (srcBtn) { toggleArr(state.filters[state.kind], '_src', srcBtn.getAttribute('data-src')); render(); return; }
      var ftog = t.closest('[data-facet-toggle]'); if (ftog) { var fk = ftog.closest('[data-facet]').getAttribute('data-facet'); state.openMenu = (state.openMenu === fk) ? null : fk; renderSidebar(); return; }
      var fadd = t.closest('[data-facet-add]'); if (fadd) { var k = fadd.closest('[data-facet]').getAttribute('data-facet'); toggleArr(state.filters[state.kind], k, fadd.getAttribute('data-facet-add')); state.openMenu = null; renderSidebar(); renderResults(); renderActive(); return; }
      var frm = t.closest('[data-facet-rm]'); if (frm) { var k2 = frm.closest('[data-facet]').getAttribute('data-facet'); toggleArr(state.filters[state.kind], k2, frm.getAttribute('data-facet-rm')); renderSidebar(); renderResults(); renderActive(); return; }
      var rmchip = t.closest('[data-rmchip]'); if (rmchip) { removeChip(rmchip); return; }
      var act = t.closest('[data-act]'); if (act) { e.stopPropagation(); var it = findItem(act.getAttribute('data-act')); if (it) (it.perm === 'locked' ? openModal(it) : doDownload(it, act)); return; }
      // Plan §19.5 — release-card click resolves to the release-drawer
      // (lookup either by cloud_release_id or release_dir).
      var rel = t.closest('[data-open-release]');
      if (rel) {
        e.stopPropagation();
        var rk = rel.getAttribute('data-open-release');
        var sceneSlug = rel.getAttribute('data-scene-slug') || '';
        var r = (state.releaseById && state.releaseById[rk]) || (state.releaseByDir && state.releaseByDir[rk]);
        if (r) {
          // Plan §26 — if click came from an Individual-Maps card, pass the
          // matching scene so the drawer can show the BM+SC sibling pair.
          var selectedScene = null;
          if (sceneSlug && Array.isArray(r.scenes)) {
            for (var si = 0; si < r.scenes.length; si++) {
              if (r.scenes[si].scene_slug === sceneSlug) { selectedScene = r.scenes[si]; break; }
            }
          }
          openReleaseDrawer(r, selectedScene);
        }
        return;
      }
      // Plan §72.4 - Bundle-Card click -> Bundle-Drawer with per-sub-release downloads.
      var bcell = t.closest('[data-open-bundle]');
      if (bcell) {
        e.stopPropagation();
        var bid = bcell.getAttribute('data-open-bundle');
        var b = (state.bundleById && state.bundleById[bid]) || null;
        if (b) openBundleDrawer(b);
        return;
      }
      var open = t.closest('[data-open]'); if (open) { var io = findItem(open.getAttribute('data-open')); if (io) openModal(io); return; }
    }
    function toggleArr(obj, key, val) { var a = obj[key] || (obj[key] = []); var i = a.indexOf(val); if (i === -1) a.push(val); else a.splice(i, 1); state.visible = PAGE; }
    function removeChip(el) {
      var t = el.getAttribute('data-rmchip'), f = state.filters[state.kind];
      if (t === 'perm') toggleArr(f, '_perm', el.getAttribute('data-rmval'));
      else if (t === 'range') f._range = [0, FACETS[state.kind].range.max];
      else toggleArr(f, el.getAttribute('data-rmkey'), el.getAttribute('data-rmval'));
      render();
    }
    // close facet menu on outside click
    document.addEventListener('click', function (e) { if (state.openMenu && !e.target.closest('[data-facet]')) { state.openMenu = null; if (state.loaded) renderSidebar(); } });

    function doDownload(it, btn) {
      if (!it.cloudId) { toast('Preparing…'); }
      if (btn) btn.setAttribute('disabled', 'disabled');
      var param = it.cloudId ? ('resource=download&asset_id=' + encodeURIComponent(it.cloudId)) : ('resource=download&key=' + encodeURIComponent(it.key));
      fetch(withParam(proxyUrl, param), { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (j) { if (j && j.result === 'OK' && j.url) window.location.href = j.url; if (btn) btn.removeAttribute('disabled'); })
        .catch(function () { if (btn) btn.removeAttribute('disabled'); });
    }

    // Plan §72.4 - Bundle-Drawer. Single-column layout with cover-hero,
    // Download-All cascade button, per-sub-release download rows. Renders
    // the same `mdl-product` blocks as openReleaseDrawer for visual
    // consistency. Download-All triggers N browser-downloads sequentially
    // with 800ms delay (no server-side aggregation).
    function openBundleDrawer(b) {
      var host = root.querySelector('[data-modal]');
      if (!host || !b) return;
      var cov = b.cover_url || (b.members && b.members[0] ? releaseCoverUrl(state.releaseById[b.members[0].asset_id] || {}) : '');
      var memCount = (b.members || []).length;
      var sizeTxt = b.bytes_total ? humanBytes(b.bytes_total) : '';
      var sub = memCount + ' release' + (memCount === 1 ? '' : 's') + (sizeTxt ? ' · ' + sizeTxt + ' total' : '');

      // Build a flat list of (asset_id, primary download URL) tuples for the
      // Download-All cascade. We pick the first non-locked available download
      // per member (highest user-priority based on backend resolver).
      var cascadeTargets = [];
      (b.members || []).forEach(function (m) {
        var dl = (m.available_downloads || []).find(function (d) { return d.state !== 'locked' && d.download_path; });
        if (dl) cascadeTargets.push({ asset_id: m.asset_id, label: m.name, href: proxyUrl + dl.download_path, bytes: dl.bytes || 0, kind: dl.kind || '' });
      });

      var memberRowsHtml = (b.members || []).map(function (m) {
        var mCov = releaseCoverUrl(state.releaseById[m.asset_id] || {});
        var mSize = m.bytes ? humanBytes(m.bytes) : '';
        var downloads = m.available_downloads || [];
        var dlBlocks = downloads.map(function (d) {
          var byte = d.bytes ? ' · ' + humanBytes(d.bytes) : '';
          if (d.state === 'locked') {
            var ctaLabel = d.unlock_cta_label || T('search.unlock', 'Unlock');
            var ctaUrl   = d.unlock_cta_url   || patreonUrl;
            var ctaText  = d.kind === 'scenepacker_zip' ? T('search.cta_buy_pack', 'Buy pack') : T('search.cta_join_patreon', 'Join Patreon');
            return '<div class="mdl-product mdl-product-locked">' +
              '<div><div class="mp-t">' + SVG.lock + ' ' + esc(d.label || d.kind || 'Download') + '</div>' +
              '<div class="mp-s">' + esc(ctaLabel + byte) + '</div></div>' +
              '<a class="btn ghost sm" href="' + esc(ctaUrl) + '" target="_blank" rel="noopener">' + esc(ctaText) + '</a></div>';
          }
          var btnCls = (d.kind === 'scenepacker_zip') ? 'btn ghost sm' : 'btn primary sm';
          var mHref = d.download_path ? (proxyUrl + d.download_path) : '#';
          return '<div class="mdl-product"><div><div class="mp-t">' + esc(d.label || d.kind || 'Download') + '</div>' +
            '<div class="mp-s">' + esc((d.source || '') + byte) + '</div></div>' +
            '<a class="' + btnCls + '" href="' + esc(mHref) + '" download rel="noopener">' + SVG.dl + ' Download</a></div>';
        }).join('');
        if (!dlBlocks) dlBlocks = '<div class="mp-s" style="opacity:0.6">No downloads available for this release.</div>';
        return '<div class="bm-bundle-member">' +
          '<div class="bm-bundle-member-head">' +
            '<div class="bm-bundle-member-thumb">' + (mCov ? '<img src="' + esc(mCov) + '" alt="">' : '<span class="glyph" aria-hidden="true">' + esc((m.name || '?').slice(0, 1)) + '</span>') + '</div>' +
            '<div class="bm-bundle-member-meta">' +
              '<div class="bm-bundle-member-name">' + esc(m.name || m.filename) + '</div>' +
              (mSize ? '<div class="bm-bundle-member-sub">' + esc(mSize) + '</div>' : '') +
            '</div>' +
          '</div>' +
          '<div class="mdl-products">' + dlBlocks + '</div>' +
        '</div>';
      }).join('');

      var dlAllButton = cascadeTargets.length
        ? '<button class="btn primary lg bm-bundle-dlall" data-bm-bundle-dlall>' + SVG.dl +
            ' Download All (' + cascadeTargets.length + ' release' + (cascadeTargets.length === 1 ? '' : 's') +
            (sizeTxt ? ', ' + sizeTxt : '') + ')</button>'
        : '<span class="btn ghost lg" style="cursor:default;opacity:0.6">' + esc(T('search.no_downloads', 'No downloads available')) + '</span>';

      host.innerHTML = '<div class="mdl-back" data-mclose><div class="mdl lg bm-drawer bm-bundle-drawer" data-mstop>' +
        '<button class="mdl-close" data-mclose>' + SVG.x + '</button>' +
        '<div class="bm-drawer-hero">' +
          (cov ? '<img src="' + esc(cov) + '" alt="">' : '<span class="glyph" aria-hidden="true">' + esc((b.name || '?').slice(0, 1)) + '</span>') +
        '</div>' +
        '<div class="bm-drawer-head">' +
          '<h3>' + esc(b.name || b.slug) + '</h3>' +
          '<div class="mh-sub">' + esc(sub) + '</div>' +
        '</div>' +
        '<div class="bm-drawer-body">' +
          (b.description ? '<div class="bm-bundle-desc">' + esc(b.description) + '</div>' : '') +
          '<section class="bm-drawer-section bm-bundle-dlall-section">' +
            dlAllButton +
            '<div class="bm-bundle-dlall-hint">' +
              '<strong>Warning:</strong> Triggers ' + cascadeTargets.length + ' sequential downloads (~' + (sizeTxt || 'unknown size') +
              '). ' + T('search.dl_all_hint', 'If you cancel mid-way, click Download All again to retry. Some browsers may block multi-download, so allow it when prompted.') +
            '</div>' +
          '</section>' +
          '<section class="bm-drawer-section">' +
            '<h4 class="bm-drawer-section-h">' + esc(T('search.included_releases', 'Included releases')) + ' (' + memCount + ')</h4>' +
            '<div class="bm-bundle-members">' + memberRowsHtml + '</div>' +
          '</section>' +
        '</div>' +
      '</div></div>';

      // Wire close + Download-All cascade.
      Array.prototype.forEach.call(host.querySelectorAll('[data-mclose]'), function (el) {
        el.addEventListener('click', function () { host.innerHTML = ''; });
      });
      var dlAllBtn = host.querySelector('[data-bm-bundle-dlall]');
      if (dlAllBtn && cascadeTargets.length) {
        dlAllBtn.addEventListener('click', function () {
          if (!window.confirm(T('search.dl_confirm_pre', 'Download') + ' ' + cascadeTargets.length + ' ' + T('search.dl_confirm_mid', 'files sequentially (~') + (sizeTxt || T('search.dl_unknown', 'unknown')) + ' ' + T('search.dl_confirm_post', 'total)? This may take a while.'))) return;
          dlAllBtn.disabled = true;
          dlAllBtn.textContent = T('search.dl_triggering', 'Triggering downloads...');
          cascadeTargets.forEach(function (target, idx) {
            setTimeout(function () {
              var a = document.createElement('a');
              a.href = target.href;
              a.setAttribute('download', '');
              a.setAttribute('rel', 'noopener');
              document.body.appendChild(a);
              a.click();
              document.body.removeChild(a);
              if (idx === cascadeTargets.length - 1) {
                setTimeout(function () {
                  dlAllBtn.textContent = '✓ ' + T('search.dl_all_done_pre', 'All') + ' ' + cascadeTargets.length + ' ' + T('search.dl_all_done_post', 'downloads triggered');
                }, 200);
              }
            }, idx * 800);
          });
        });
      }
    }

    // Plan §19.5 / §26 — Release-Drawer modal. Shown when the user clicks a
    // release card in Releases-view OR an individual-map card that resolves
    // to a parent release. Renders a download-button per item of the
    // release's `available_downloads` payload from app-proxy.php. When
    // selectedScene is provided (Individual-Maps click), an extra "Selected
    // scene" row shows the BM+SC sibling pair side-by-side so the user sees
    // which two assets get installed together.
    function openReleaseDrawer(r, selectedScene) {
      if (!r) return;
      var host = root.querySelector('[data-modal]');
      // Plan §47.1 — single-column scroll-friendly layout. Cover as hero,
      // then sequential sections: Downloads → What's Included → Scenes →
      // Player Handouts. Werbecharakter prominent durch ✓-bullets + grosse
      // Zahlen.
      var heroCov = releaseCoverUrl(r);
      // Hide the "Foundry VTT Manual Import" buy-pack teaser while no pack is
      // actually purchasable in the shop: a locked scenepacker_zip row only
      // offers a dead "Buy pack" CTA today. Unlocked ones (admin / actual
      // owners) still render, so re-enabling shop sales needs no change here.
      var dls = (r.available_downloads || []).filter(function (d) {
        return !(d && d.kind === 'scenepacker_zip' && d.state === 'locked');
      });
      var st  = r.stats || null;
      var subBits = [];
      if (r.release_num) subBits.push(T('search.row_release', 'Release') + ' ' + r.release_num);
      if (r.bytes_total) subBits.push(humanBytes(r.bytes_total));
      if (Array.isArray(r.variants_available) && r.variants_available.length) {
        subBits.push(r.variants_available.join(' + '));
      }
      var sub = subBits.join(' · ');

      // Plan §47.1 — WHAT'S INCLUDED Werbe-Bullets (✓ glyph + bold counts).
      var perksHtml = '';
      if (st && (st.total_scenes || st.handouts || st.ambient_tracks)) {
        var p = function (n, sing, plur, note) {
          var label = (n === 1 ? sing : (plur || sing + 's'));
          return '<li><span class="bm-perk-n">' + n + '</span> ' + esc(label) + (note ? ' <span class="bm-perk-note">' + esc(note) + '</span>' : '') + '</li>';
        };
        // Ambient duration: each track is a 10-minute loop per Beneos encoding
        // convention. Surface the total runtime in brackets — minutes under
        // an hour, "Xh Ymin" once it tips over.
        var ambientNote = '';
        if (st.ambient_tracks) {
          var minsTotal = st.ambient_tracks * 10;
          if (minsTotal < 60)        ambientNote = minsTotal + ' min total';
          else if (minsTotal % 60 === 0) ambientNote = (minsTotal / 60) + ' h total';
          else                       ambientNote = Math.floor(minsTotal / 60) + ' h ' + (minsTotal % 60) + ' min total';
        }
        var bullets = [];
        if (st.battlemaps)     bullets.push(p(st.battlemaps,     T('search.sc_battlemap', 'Battlemap Scene'),     T('search.sc_battlemaps', 'Battlemap Scenes'),     'animated'));
        if (st.sceneries)      bullets.push(p(st.sceneries,      T('search.sc_scenery', 'Scenery Variant'),     T('search.sc_sceneries', 'Scenery Variants'),     'animated'));
        if (st.intros)         bullets.push(p(st.intros,         T('search.sc_intro', 'Intro Cinematic'),     T('search.sc_intros', 'Intro Cinematics'),     'animated'));
        if (st.overview)       bullets.push(p(st.overview,       T('search.sc_overview', 'Overview Map'),        T('search.sc_overviews', 'Overview Maps'),        'animated'));
        if (st.standalones)    bullets.push(p(st.standalones,    T('search.sc_standalone', 'Standalone Map'),      T('search.sc_standalones', 'Standalone Maps'),      'animated'));
        if (st.handouts)       bullets.push(p(st.handouts,       T('search.sc_handout', 'Player Handout'),      T('search.sc_handouts', 'Player Handouts')));
        if (st.ambient_tracks) bullets.push(p(st.ambient_tracks, T('search.sc_ambient', 'Ambient Audio Track'), T('search.sc_ambients', 'Ambient Audio Tracks'), ambientNote));
        if (bullets.length) {
          perksHtml = '<section class="bm-drawer-section bm-drawer-perks">' +
            '<h4 class="bm-drawer-section-h">What\'s included</h4>' +
            '<ul class="bm-perks">' + bullets.join('') + '</ul>' +
          '</section>';
        }
      }

      // Trailer trigger lives as a small YouTube icon next to the title row.
      // Click flips the iframe panel below the head section (existing
      // data-bm-trailer-host wire-up). Tooltip auf Deutsch per User-Wunsch.
      var trailerIcon = '';
      var trailerToToggle = r.trailer_url || r.videourl || '';
      if (trailerToToggle) {
        trailerIcon = '<button type="button" class="bm-trailer-icon" data-bm-trailer="' + esc(trailerToToggle) + '" title="Trailer abspielen" aria-label="Trailer abspielen">' +
          '<svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M23 7.2a3 3 0 0 0-2.1-2.1C19 4.6 12 4.6 12 4.6s-7 0-8.9.5A3 3 0 0 0 1 7.2C.6 9.1.6 12 .6 12s0 2.9.4 4.8a3 3 0 0 0 2.1 2.1c1.9.5 8.9.5 8.9.5s7 0 8.9-.5A3 3 0 0 0 23 16.8c.4-1.9.4-4.8.4-4.8s0-2.9-.4-4.8zM9.6 15.6V8.4l6 3.6-6 3.6z"/></svg>' +
        '</button>';
      }

      // Plan §47.1 — Downloads section. Same per-row template as before,
      // but lifted to its own block above the perks list.
      var downloadsHtml = '<section class="bm-drawer-section bm-drawer-downloads">' +
        '<h4 class="bm-drawer-section-h">Downloads</h4>';
      // Foundry-module-install status notice. Plan §59.A: this is not an
      // action button — the actual install happens inside the Foundry module.
      // The row just confirms to entitled Patrons that the module-install path
      // is enabled for them, so the locked "Manual Import ZIP" below does not
      // read as a broken access.
      var directInstallHtml = '';
      if (r.can_install === true) {
        directInstallHtml = '<div class="mdl-product mdl-product-install">' +
          '<div><div class="mp-t" style="display:flex;align-items:center;gap:8px">' +
            '<span class="bm-install-check" aria-hidden="true">✓</span>Foundry module install enabled' +
          '</div>' +
          '<div class="mp-s">Install from inside Foundry, no separate ZIP download needed.</div></div>' +
        '</div>';
      }
      if (dls.length || directInstallHtml) {
        downloadsHtml += '<div class="mdl-products">' + directInstallHtml + dls.map(function (d) {
          var byte = d.bytes ? ' · ' + humanBytes(d.bytes) : '';
          // The Foundry VTT Manual Import ZIP is shop-only. Style it less
          // prominently so it doesn't compete with the primary Patreon/Tier
          // downloads above. Locked + unlocked both get the dimmed treatment.
          var rowExtra = (d.kind === 'scenepacker_zip') ? ' mdl-product-scenepacker' : '';
          if (d.state === 'locked') {
            var ctaLabel = d.unlock_cta_label || T('search.unlock_download', 'Unlock this download');
            var ctaUrl   = d.unlock_cta_url   || patreonUrl;
            var ctaText  = d.kind === 'scenepacker_zip' ? T('search.cta_buy_pack', 'Buy pack') : T('search.cta_join_patreon', 'Join Patreon');
            return '<div class="mdl-product mdl-product-locked' + rowExtra + '">' +
              '<div><div class="mp-t" style="display:flex;align-items:center;gap:8px">' +
                '<span style="opacity:0.6">' + SVG.lock + '</span>' + esc(d.label || d.kind || 'Download') +
              '</div>' +
              '<div class="mp-s" style="color:var(--ink-mute)">' + esc(ctaLabel + byte) + '</div></div>' +
              '<a class="btn ghost sm" href="' + esc(ctaUrl) + '" target="_blank" rel="noopener">' + esc(ctaText) + '</a></div>';
          }
          var dlState = '';
          if (d.downloaded_at) {
            var dDate = fmtDownloadDate(d.downloaded_at);
            dlState = d.is_stale
              ? '<span class="mp-dlstate stale">! Update available' + (dDate ? ' since ' + esc(dDate) : '') + '</span>'
              : '<span class="mp-dlstate fresh">✓ Downloaded' + (dDate ? ' ' + esc(dDate) : '') + '</span>';
          }
          var btnCls = (d.kind === 'scenepacker_zip') ? 'btn ghost sm' : 'btn primary sm';
          // Download goes through the same-origin recording redirect endpoint
          // (resource=bm_download): it records the download (green tick) and
          // 302s to a freshly signed URL, so links never expire mid-session.
          var dlHref = d.download_path ? (proxyUrl + d.download_path) : (d.url || '#');
          return '<div class="mdl-product' + rowExtra + '"><div><div class="mp-t">' + esc(d.label || d.kind || 'Download') + '</div>' +
            '<div class="mp-s">' + esc((d.source || '') + byte) + '</div>' + dlState + '</div>' +
            '<a class="' + btnCls + '" data-dl-trigger href="' + esc(dlHref) + '" download rel="noopener">' + SVG.dl + ' Download</a></div>';
        }).join('') + '</div>';
      } else {
        downloadsHtml += '<div style="font-size:13px;color:var(--ink-mute);line-height:1.55">No downloads available yet. Patreon access unlocks installation in the Foundry module; shop purchases unlock the ZIP download here.</div>' +
          '<div style="margin-top:14px"><a class="btn ghost sm" href="' + esc(patreonUrl) + '" target="_blank" rel="noopener">Become a patron</a></div>';
      }
      downloadsHtml += '</section>';

      // Plan §49.A — 2-column compact scene layout: small BM+SC thumbnails
      // on the LEFT, title on the RIGHT. Native thumb resolution (~500x500)
      // looks blurry when upscaled to card-width, so keep them at ~90x50.
      var scenesHtml = '';
      if (Array.isArray(r.scenes) && r.scenes.length) {
        var rows = r.scenes.map(function (sc) {
          var cleanName = (sc.name || sc.scene_slug || '').replace(/^(BM|SC):\s*/i, '').trim();
          // Intro sequences are not battlemaps — label them "Intro" when the
          // scene name says so. Everything else keeps the default Battlemap label.
          var primLabel = /intro/i.test(sc.name || sc.scene_slug || '') ? T('search.label_intro', 'Intro') : T('search.label_battlemap', 'Battlemap');
          var primImg = sc.thumbnail ? '<img loading="lazy" src="' + esc(sc.thumbnail) + '" alt=""><div class="bm-scene-label">' + esc(primLabel) + '</div>' : '<span class="glyph" aria-hidden="true"></span>';
          var sibImg  = sc.sibling_thumbnail ? '<img loading="lazy" src="' + esc(sc.sibling_thumbnail) + '" alt=""><div class="bm-scene-label">Scenery</div>' : '';
          return '<div class="bm-scene-row">' +
            '<div class="bm-scene-row-thumbs">' +
              '<div class="bm-scene-thumb">' + primImg + '</div>' +
              (sibImg ? '<div class="bm-scene-thumb">' + sibImg + '</div>' : '') +
            '</div>' +
            '<div class="bm-scene-row-title">' + esc(cleanName) + '</div>' +
          '</div>';
        }).join('');
        scenesHtml = '<section class="bm-drawer-section bm-drawer-scenes">' +
          '<h4 class="bm-drawer-section-h">Scenes in this release (' + r.scenes.length + ')</h4>' +
          '<div class="bm-scene-list">' + rows + '</div>' +
        '</section>';
      }

      // Plan §47.3 — Handouts inline (auto-fetched lazy). Click → existing Lightbox.
      // Future-slot for Journal/Actor JSON preview lives further down (hidden V1).
      var handoutsHtml = '';
      if (releaseHasGallery(r)) {
        handoutsHtml = '<section class="bm-drawer-section bm-drawer-handouts">' +
          '<h4 class="bm-drawer-section-h">Player Handouts</h4>' +
          '<div data-bm-handouts><div class="bm-loading">Loading…</div></div>' +
          '<div class="bm-handouts-note">Click any image to view full size. Direct download will be added soon.</div>' +
        '</section>';
      }

      host.innerHTML = '<div class="mdl-back" data-mclose><div class="mdl lg bm-drawer" data-mstop>' +
        '<button class="mdl-close" data-mclose>' + SVG.x + '</button>' +
        '<div class="bm-drawer-hero">' +
          (heroCov ? '<img src="' + esc(heroCov) + '" alt="">' : '<span class="glyph" aria-hidden="true">' + esc((r.display_name || '?').slice(0, 1)) + '</span>') +
        '</div>' +
        '<div class="bm-drawer-head">' +
          '<div class="bm-drawer-title-row"><h3>' + esc(r.display_name || r.release_dir) + '</h3>' + trailerIcon + '</div>' +
          '<div class="mh-sub">' + esc(sub) + '</div>' +
          '<div data-bm-trailer-host></div>' +
        '</div>' +
        '<div class="bm-drawer-body">' +
          downloadsHtml +
          perksHtml +
          scenesHtml +
          handoutsHtml +
          '<div class="bm-drawer-section bm-future-content" data-bm-future hidden></div>' +
        '</div>' +
        '<div class="mdl-f"><button class="btn ghost sm" data-mclose>Close</button></div>' +
        '</div></div>';
      host.querySelector('[data-mstop]').addEventListener('click', function (e) { e.stopPropagation(); });
      Array.prototype.forEach.call(host.querySelectorAll('[data-mclose]'), function (b) { b.addEventListener('click', function () { host.innerHTML = ''; }); });
      // Plan §53.A — hover-zoom on scene-thumbs (BM+SC pair) in the drawer.
      attachHoverZoom(host);
      // Plan §33.4 — clicking a download triggers a silent library re-fetch
      // (debounced 800ms) so the freshly-recorded download flips the badge
      // to green / clears the stale flag without a full page reload.
      Array.prototype.forEach.call(host.querySelectorAll('[data-dl-trigger]'), function (a) {
        a.addEventListener('click', function () { scheduleLibraryRefresh(); });
      });
      // Plan §46.6 — Watch-Trailer button. Toggles an inline iframe for
      // YouTube + Vimeo URLs, opens an external tab for everything else.
      var trBtn = host.querySelector('[data-bm-trailer]');
      var trHost = host.querySelector('[data-bm-trailer-host]');
      if (trBtn && trHost) trBtn.addEventListener('click', function () {
        var url = trBtn.getAttribute('data-bm-trailer') || '';
        var embed = trailerEmbedHtml(url);
        if (!embed) { window.open(url, '_blank', 'noopener,noreferrer'); return; }
        if (trHost.innerHTML) { trHost.innerHTML = ''; return; } // toggle off
        trHost.innerHTML = '<div style="margin-top:12px;border:1px solid var(--line);border-radius:var(--radius);overflow:hidden">' + embed + '</div>';
      });
      // Plan §47.3 — Handouts inline. Auto-fetch on drawer open, render as
      // grid in the dedicated section. Cover + scene thumbs are already
      // shown elsewhere (hero, scenes section) so we filter them out and
      // surface only `kind === 'handout'` items. Click → existing Lightbox.
      var handoutsBox = host.querySelector('[data-bm-handouts]');
      if (handoutsBox) {
        fetchReleaseMedia(r.release_dir || '').then(function (media) {
          var handouts = (media || []).filter(function (m) { return m && m.kind === 'handout'; });
          if (!handouts.length) {
            handoutsBox.innerHTML = '<div class="bm-empty-mini">No player handouts in this release.</div>';
            return;
          }
          // Plan §50.E — data-src + IntersectionObserver. Tile starts with
          // spinner overlay (.is-loading), the lazy-load callback removes it.
          var grid = '<div class="bm-gallery-grid">' + handouts.map(function (m, i) {
            return '<button class="bm-gallery-tile is-loading" type="button" data-bm-lb-idx="' + i + '" title="' + esc(m.label || T('search.sc_handout', 'Player Handout')) + '">' +
                   '<span class="bm-tile-spin" aria-hidden="true"></span>' +
                   '<img data-src="' + esc(m.signed_url) + '" alt=""></button>';
          }).join('') + '</div>';
          handoutsBox.innerHTML = grid;
          attachLazyImages(handoutsBox);
          attachHoverZoom(handoutsBox);
          Array.prototype.forEach.call(handoutsBox.querySelectorAll('[data-bm-lb-idx]'), function (b) {
            b.addEventListener('click', function () {
              openLightbox(handouts, parseInt(b.getAttribute('data-bm-lb-idx'), 10) || 0);
            });
          });
        });
      }
    }

    // ---------- modal (detail + Layer 2 products) ----------
    function openModal(it) {
      // Plan §19.5 — battlemap items resolve to their parent release's
      // download set when one exists. Single-button per-asset download is
      // replaced by the per-release download drawer.
      if (it && it.kind === 'battlemap') {
        var rel = releaseFor(it);
        if (rel) { openReleaseDrawer(rel); return; }
      }
      var host = root.querySelector('[data-modal]');
      var locked = it.perm === 'locked';
      var p = it.props;
      var kv = '';
      function row(k, v) { if (v == null || v === '') return; kv += '<dt>' + esc(k) + '</dt><dd>' + esc(v) + '</dd>'; }
      row(T('search.row_type', 'Type'), it.kind === 'token' ? typeStr(p) : (p.type || p.item_type || p.school));
      if (it.kind === 'token') row(T('search.row_cr', 'CR'), p.cr);
      if (it.kind === 'spell') row(T('search.row_level', 'Level'), p.level);
      if (it.kind === 'item') { row(T('search.row_rarity', 'Rarity'), p.rarity); row(T('search.row_origin', 'Origin'), p.origin); }
      if (p.biom) row(T('search.row_biome', 'Biome'), (Array.isArray(p.biom) ? p.biom : [p.biom]).filter(function (b) { return b && b !== 'None'; }).map(function (b) { return loc('common.biome', b); }).join(', '));
      if (p.download_pack) row(T('search.row_release', 'Release'), p.download_pack);
      // Plan §58.2 — entitled item/spell/token cards get a richer body:
      // ZIP + PDF download buttons plus front/back (or 5-up token previews).
      // Marker div is rendered now and async-filled by loadAssetParts.
      var canShowParts = !locked && (it.kind === 'item' || it.kind === 'spell' || it.kind === 'token');
      host.innerHTML = '<div class="mdl-back" data-mclose><div class="mdl lg" data-mstop>' +
        '<div class="mdl-h"><div><div class="mh-eyebrow">' + esc(FACETS[it.kind].tab) + '</div><h3>' + esc(it.name) + '</h3>' +
          '<div class="mh-sub">' + esc(subFor(it)) + '</div></div><button class="mdl-close" data-mclose>' + SVG.x + '</button></div>' +
        '<div class="mdl-b mdl-media-grid' + (it.kind === 'item' || it.kind === 'spell' ? ' mdl-thumb-sm' : '') + '">' +
          '<div class="acard-thumb" data-aspect="' + (it.kind === 'item' ? 'square' : FACETS[it.kind].aspect) + '"' + thumbStyle(it) + ' style="border-radius:var(--radius);border:1px solid var(--line)">' + (it.thumb ? '<img src="' + esc(it.thumb) + '" alt="">' : '<span class="glyph" aria-hidden="true">' + esc(it.name.slice(0, 1)) + '</span>') + '</div>' +
          '<div><div style="margin-bottom:12px">' + permChip(it.perm) + '</div>' + (it.desc ? '<p style="font-size:13px;color:var(--ink-mute);line-height:1.55;margin:0 0 14px">' + esc(it.desc) + '</p>' : '') +
            '<dl class="kv">' + kv + '</dl>' +
            (locked ? '<div data-products style="margin-top:16px"><div class="brw-loading" style="padding:14px 0;font-size:13px">Finding where to get this…</div></div>' : '') +
            (canShowParts ? '<div class="bm-asset-extra" data-asset-extra><div class="bm-asset-loading">Loading downloads…</div></div>' : '') +
          '</div>' +
        '</div>' +
        '<div class="mdl-f"><button class="btn ghost sm" data-mclose>Close</button>' +
          (locked
            ? '<a class="btn ghost sm" href="' + esc(patreonUrl) + '" target="_blank" rel="noopener">Become a patron</a>'
            : (it.kind === 'battlemap' && it.canDownloadZip === false
                ? '<span class="btn ghost sm" title="Patreon access unlocks the install path in the Foundry module. Shop purchases also unlock the ZIP download." style="cursor:default">Install in the Foundry module</span>'
                : '<button class="btn primary sm" data-act="' + esc(it.key) + '" data-modal-dl>' + SVG.dl + ' Download</button>')) +
        '</div></div></div>';
      host.querySelector('[data-mstop]').addEventListener('click', function (e) { e.stopPropagation(); });
      Array.prototype.forEach.call(host.querySelectorAll('[data-mclose]'), function (b) { b.addEventListener('click', function () { host.innerHTML = ''; }); });
      var dlBtn = host.querySelector('.mdl-f [data-act]');
      if (dlBtn) dlBtn.addEventListener('click', function () { doDownload(it, dlBtn); });
      if (locked) loadProducts(it, host.querySelector('[data-products]'));
      if (canShowParts) loadAssetParts(it, host);
    }

    // Open the online Creature Codex in a new tab for an entitled token. The
    // signed codex URL is fetched async, which would trip popup blockers if we
    // opened the tab after the fetch resolves — so we open a blank tab inside
    // the click gesture and redirect it once the URL arrives (or close it on
    // failure). Mirrors the entitlement-gated resource=download pattern.
    function openCodex(assetId, btn) {
      if (!assetId) return;
      var tab = window.open('', '_blank');           // synchronous: keeps the user gesture
      try { if (tab && tab.document) tab.document.write('<!doctype html><title>Loading codex…</title><body style="background:#0d0a08"></body>'); } catch (e) {}
      if (btn) btn.setAttribute('disabled', 'disabled');
      var lang = (document.documentElement.getAttribute('lang') || 'en');
      var url = withParam(proxyUrl, 'resource=codex_link&asset_id=' + encodeURIComponent(assetId) + '&lang=' + encodeURIComponent(lang));
      fetch(url, { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (j) {
          if (j && j.result === 'OK' && j.url) {
            if (tab) tab.location.href = j.url; else window.open(j.url, '_blank', 'noopener');
          } else {
            if (tab) tab.close();
            toast(T('search.codex_failed', 'Could not open the codex. Please try again.'));
          }
        })
        .catch(function () { if (tab) tab.close(); toast(T('search.codex_failed', 'Could not open the codex. Please try again.')); })
        .finally(function () { if (btn) btn.removeAttribute('disabled'); });
    }

    // Plan §58.2 — fetch ZIP/PDF/preview URLs for an entitled item/spell/token
    // and lay them out under the kv-table. Locked users never hit this path
    // (see openModal canShowParts gate); a defensive 403 from the backend
    // still leaves the placeholder hidden.
    function loadAssetParts(it, host) {
      var extra = host.querySelector('[data-asset-extra]');
      if (!extra) return;
      var assetId = it.cloudId || it.id || it.asset_id;
      if (!assetId) { extra.innerHTML = ''; return; }
      fetch(withParam(proxyUrl, 'resource=asset_parts&asset_id=' + encodeURIComponent(assetId)), { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (j) {
          if (!j || j.result !== 'OK' || !j.data) { extra.innerHTML = ''; return; }
          var parts = j.data.parts || {};
          // Hide the "Dynamic" tile: it has no use in this drawer.
          var previews = (j.data.previews || []).filter(function (pv) { return pv.kind !== 'dynamic'; });
          var fileBtns = [];
          // Creatures (tokens) get an online codex view — opens the full
          // stat-block / tactical guide in a new tab, no download needed.
          if (it.kind === 'token') {
            fileBtns.push('<button type="button" class="btn ghost sm" data-codex>' +
              '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="vertical-align:-2px"><path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"/><path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"/></svg>' +
              ' View Codex</button>');
          }
          if (parts.pdf && parts.pdf.url) {
            fileBtns.push('<a class="btn ghost sm" href="' + esc(parts.pdf.url) + '" target="_blank" rel="noopener">' + SVG.dl + ' PDF</a>');
          }
          if (parts.zip && parts.zip.url) {
            fileBtns.push('<a class="btn primary sm" href="' + esc(parts.zip.url) + '">' + SVG.dl + ' ZIP</a>');
          }
          var html = '';
          if (fileBtns.length) {
            html += '<div class="bm-asset-files">' + fileBtns.join('') + '</div>';
          }
          if (previews.length) {
            html += '<div class="bm-asset-previews' + (previews.length > 2 ? ' grid-many' : '') + '">';
            previews.forEach(function (pv, idx) {
              html += '<button type="button" class="bm-asset-preview-item" data-asset-preview-idx="' + idx + '" title="' + esc(pv.label) + '">' +
                '<img src="' + esc(pv.url) + '" alt="" loading="lazy">' +
                '<span class="bm-asset-preview-label">' + esc(pv.label) + '</span>' +
                '</button>';
            });
            html += '</div>';
          }
          extra.innerHTML = html || '';
          // Wire the "View Codex" button (tokens only).
          var codexBtn = extra.querySelector('[data-codex]');
          if (codexBtn) codexBtn.addEventListener('click', function () { openCodex(it.cloudId || it.id || it.asset_id, codexBtn); });
          // Clicking a preview swaps the main detail image in place (kept small)
          // rather than popping open a lightbox.
          var mainImg = host.querySelector('.acard-thumb img');
          var previewBtns = extra.querySelectorAll('[data-asset-preview-idx]');
          Array.prototype.forEach.call(previewBtns, function (btn) {
            btn.addEventListener('click', function () {
              var pv = previews[parseInt(btn.getAttribute('data-asset-preview-idx'), 10) || 0];
              if (!pv || !mainImg) return;
              mainImg.src = pv.url;
              Array.prototype.forEach.call(previewBtns, function (b) { b.classList.remove('is-active'); });
              btn.classList.add('is-active');
            });
          });
          // Hide the footer Download once we have the ZIP button — both
          // would download the same archive, so the duplicate is noise.
          var footerDl = host.querySelector('[data-modal-dl]');
          if (footerDl && parts.zip) footerDl.style.display = 'none';
        })
        .catch(function () { extra.innerHTML = ''; });
    }

    function loadProducts(it, box) {
      if (!box) return;
      var done = function (list, patreonOnly) {
        if ((!list || !list.length) && !patreonOnly) { box.innerHTML = '<div style="font-size:12.5px;color:var(--ink-dim)">Available to patrons. Link Patreon to unlock, or check the shop.</div>'; return; }
        var html = '<div class="fchip-grp-h" style="padding:0;border:0;margin-bottom:8px"><span class="t">Where to get it</span></div><div class="mdl-products">';
        (list || []).forEach(function (pr) {
          html += '<div class="mdl-product"><div><div class="mp-t">' + esc(pr.product_name) + '</div><div class="mp-s">' + esc(pr.kind === 'bundle' ? 'Bundle' : 'Pack') + '</div></div>' +
            '<a class="btn primary sm" href="/products/' + esc(pr.handle) + '">Buy</a></div>';
        });
        if (patreonOnly) html += '<div class="mdl-product"><div><div class="mp-t">Patreon</div><div class="mp-s">Membership unlocks this</div></div><a class="btn ghost sm" href="' + esc(patreonUrl) + '" target="_blank" rel="noopener">Join</a></div>';
        box.innerHTML = html + '</div>';
      };
      if (state.productCache[it.key]) { var c = state.productCache[it.key]; done(c.products, c.patreon_only); return; }
      fetch(withParam(proxyUrl, 'resource=products_for_asset&key=' + encodeURIComponent(it.key)), { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (j) { var d = (j && j.data) || {}; state.productCache[it.key] = d; done(d.products, d.patreon_only); })
        .catch(function () { box.innerHTML = '<div style="font-size:12.5px;color:var(--ink-dim)">Available via Patreon or the shop.</div>'; });
    }

    var _mt;
    function toast(msg) {
      // Ueber DOCUMENT suchen, nicht ueber root: das Element haengt an document.body und
      // war in root deshalb nie auffindbar. Folge war, dass jeder Aufruf ein neues
      // erzeugte und das clearTimeout den Ausblend-Timer des vorherigen loeschte. Die
      // alten Meldungen blieben dauerhaft bei voller Deckkraft stehen und stapelten sich.
      var el = document.querySelector('[data-toast]');
      // z-index ueber dem Downloadfenster (460): beide sitzen auf bottom:74px, ein
      // niedrigerer Wert liess die Meldung exakt dahinter verschwinden.
      if (!el) { el = document.createElement('div'); el.setAttribute('data-toast', ''); el.setAttribute('role', 'status'); el.style.cssText = 'position:fixed;left:50%;bottom:74px;transform:translateX(-50%);z-index:470;background:var(--bg-card);border:1px solid var(--gold);color:var(--ink);padding:10px 16px;border-radius:30px;font-size:13px;box-shadow:0 16px 40px oklch(0 0 0 / .5);transition:opacity .25s ease;pointer-events:none'; document.body.appendChild(el); }
      el.textContent = msg; el.style.opacity = '1'; clearTimeout(_mt);
      // Nach dem Ausblenden den Text leeren, sonst sagen Vorleseprogramme eine
      // unsichtbare Meldung weiter an.
      _mt = setTimeout(function () {
        el.style.opacity = '0';
        setTimeout(function () { if (el.style.opacity === '0') el.textContent = ''; }, 300);
      }, 2200);
    }
  }
})();
